import React, { useState, useEffect, useCallback } from "react";
import "./../../App.css";
import "./Transactions.css";
import {
  CreateButton,
  CreateSearchBarWithPlaceHolder,
} from "./../CommonObjects";
import axios from '../../api/apiClient';
import { useTable, useSortBy } from "react-table";
import { token, domain } from "./../Security";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import loadingSpinner from "./../../assets/loading.gif";
import { globalTimeFormat } from "./../Security";
// icon
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DoneIcon from "@mui/icons-material/Done";
import ImageIcon from "@mui/icons-material/Image";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import UpdateIcon from "@mui/icons-material/Update";
import { OvertimeTypeSelect } from "../../common/selectComponents/OvertimeTypeSelect";

function RequestApprovalTimeKeeper({ user, userAccess, isHideSideMenu }) {
  var header = [
    " ",
    "Reference No.",
    // "Uploaded Image",
    "Employee Id",
    "Employee",
    "Request Date",
    "Request",
    "Reason",
    "Track Approvers",
    "Status",
  ];
  var accessor = [
    "referenceNumber1",
    "referenceNumber",
    // "content",
    "employeeId",
    "fullName",
    "requestDate",
    "requestTypeDescription",
    "reason",
    "",
    "status",
  ];
  var headerForOvertimeList = [
    "Employee Id",
    "Employee",
    "Date",
    "Hours",
    "Type",
    "Status",
    "Approve",
  ];
  var accessorForOvertimeList = [
    "employeePersonalInformationId",
    "employeePersonalInformationFullName",
    "date",
    "hours",
    "overtimeType",
    "status",
    "manage",
  ];

  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };

  const [isHRHead, setIsHRHead] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [requestApproval, setRequestApproval] = useState([]);
  const [overtimeRequestData, setOvertimeRequestData] = useState([]);
  const [
    overtimeRequestDataForOvertimeList,
    setOvertimeRequestDataForOvertimeList,
  ] = useState([]);
  const [leaveRequestData, setLeaveRequestData] = useState([]);
  const [changeOfScheduleData, setChangeOfScheduleData] = useState([]);
  const [changeLogRequestData, setChangeLogRequestData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataForOvertimeList, setFilterDataForOvertimeList] = useState(
    []
  );
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [filterDataIndex2, setFilterDataIndex2] = useState(0);
  const [sortFilter, setSortFilter] = useState("");
  const [departmentIdFilter, setDepartmentIdFilter] = useState(0);
  const [currentFilterDataIndex, setCurrentFilterDataIndex] = useState(0);
  const [currentFilterDataIndex2, setCurrentFilterDataIndex2] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Employee Name");
  const [filterDataIndexForOvertimeList, setFilterDataIndexForOvertimeList] =
    useState(0);
  const [requestType, setRequestType] = useState("");
  //View
  const [viewById, setViewById] = useState("");
  const [viewImageData, setViewImageData] = useState("");
  const [showViewImage, setShowViewImage] = useState(false);
  //OT
  const [showViewOTForm, setShowViewOTForm] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [approverIdOT, setApproverIdOT] = useState("");
  const [approverNameOT, setApproverNameOT] = useState("");
  const [statusOT, setStatusOT] = useState("");
  const [dateRequested, setDateRequested] = useState("");
  const [dateCompleted, setDateCompleted] = useState("");
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [requestTypeId, setRequestTypeId] = useState("");
  const [overtimeType, setOvertimeType] = useState("");
  const [date, setDate] = useState("");
  const [hours, setHours] = useState("");
  const [hasOvertimeAllowance, setHasOvertimeAllowance] = useState(false);
  const [isAboveTwoHoursOvertime, setIsAboveTwoHoursOvertime] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonForRejection, setReasonForRejection] = useState("");
  const [downloadDate, setDownloadDate] = useState("");
  const [isGenerate, setIsGenerate] = useState("");
  const [errorState, setErrorState] = useState(false);
  const [approveConfirmation, setApproveConfirmation] = useState(false);
  const [selectedToAdd, setSelectedToAdd] = useState([]);
  const [filesOT, setFilesOT] = useState("");
  //Leave
  const [showViewLeaveForm, setShowViewLeaveForm] = useState(false);
  const [referenceNumberLeave, setReferenceNumberLeave] = useState("");
  const [
    employeePersonalInformationIdLeave,
    setEmployeePersonalInformationIdLeave,
  ] = useState("");
  const [approverIdLeave, setApproverIdLeave] = useState("");
  const [approverNameLeave, setApproverNameLeave] = useState("");
  const [requestTypeIdLeave, setRequestTypeIdLeave] = useState("");
  const [statusLeave, setStatusLeave] = useState("");
  const [dateRequestedLeave, setDateRequestedLeave] = useState("");
  const [dateCompletedLeave, setDateCompletedLeave] = useState("");
  const [
    employeePersonalInformationFullNameLeave,
    setEmployeePersonalInformationFullNameLeave,
  ] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [dateFromLeave, setDateFromLeave] = useState("");
  const [dateToLeave, setDateToLeave] = useState("");
  const [daysLeave, setDaysLeave] = useState("");
  const [isHalfDayLeave, setIsHalfDayLeave] = useState(false);
  const [reasonLeave, setReasonLeave] = useState("");
  const [reasonForRejectionLeave, setReasonForRejectionLeave] = useState("");
  const [filesLeave, setFilesLeave] = useState("");
  //Change Request
  const [showViewChangeScheduleForm, setShowViewChangeScheduleForm] =
    useState(false);
  const [referenceNumberChangeSchedule, setReferenceNumberChangeSchedule] =
    useState("");
  const [
    employeePersonalInformationIdChangeSchedule,
    setEmployeePersonalInformationIdChangeSchedule,
  ] = useState("");
  const [approverIdChangeSchedule, setApproverIdChangeSchedule] = useState("");
  const [approverNameChangeSchedule, setApproverNameChangeSchedule] =
    useState("");
  const [requestTypeIdChangeSchedule, setRequestTypeIdChangeSchedule] =
    useState("");
  const [statusChangeSchedule, setStatusChangeSchedule] = useState("");
  const [dateRequestedChangeSchedule, setDateRequestedChangeSchedule] =
    useState("");
  const [dateCompletedChangeSchedule, setDateCompletedChangeSchedule] =
    useState("");
  const [
    employeePersonalInformationFullNameChangeSchedule,
    setEmployeePersonalInformationFullNameChangeSchedule,
  ] = useState("");
  const [dateFromChangeSchedule, setDateFromChangeSchedule] = useState("");
  const [dateToChangeSchedule, setDateToChangeSchedule] = useState("");
  const [shiftScheduleFromId, setShiftScheduleFromId] = useState("");
  const [shiftScheduleToId, setShiftScheduleToId] = useState("");
  const [reasonChangeSchedule, setReasonChangeSchedule] = useState("");
  const [
    reasonForRejectionChangeSchedule,
    setReasonForRejectionChangeSchedule,
  ] = useState("");
  const [filesChangeSchedule, setFilesChangeSchedule] = useState("");
  //DTR CORRECTION
  const [showViewChangeLogRequestForm, setShowViewChangeLogRequestForm] =
    useState(false);
  const [referenceNumberChangeLog, setReferenceNumberChangeLog] = useState("");
  const [
    employeePersonalInformationIdChangeLogRequest,
    setEmployeePersonalInformationIdChangeLogRequest,
  ] = useState("");
  const [
    employeePersonalInformationFullNameChangeLogRequest,
    setEmployeePersonalInformationFullNameChangeLogRequest,
  ] = useState("");
  const [timeTypeChangeLogRequest, setTimeTypeChangeLogRequest] = useState("");
  const [dateChangeLogRequest, setDateChangeLogRequest] = useState("");
  const [timeRequestedChangeLogRequest, setTimeRequestedChangeLogRequest] =
    useState("");
  const [statusChangeLogRequest, setStatusChangeLogRequest] = useState("");
  const [reasonChangeLogRequest, setReasonChangeLogRequest] = useState("");
  const [
    reasonForRejectionChangeLogRequest,
    setReasonForRejectionChangeLogRequest,
  ] = useState("");
  const [selectedItinerary, setSelectedItinerary] = useState("");
  const [filesChangeLog, setFilesChangeLog] = useState("");
  // Update
  const [editData, setEditData] = useState([]);
  const [approveFormLeave, setApproveFormLeave] = useState(false);
  const [disapproveFormLeave, setDisapproveFormLeave] = useState(false);
  const [approveFormOT, setApproveFormOT] = useState(false);
  const [disapproveFormOT, setDisapproveFormOT] = useState(false);
  const [approveFormChangeSchedule, setApproveFormChangeSchedule] =
    useState(false);
  const [disapproveFormChangeSchedule, setDisapproveFormChangeSchedule] =
    useState(false);
  const [approveFormChangeLogRequest, setApproveFormChangeLogRequest] =
    useState(false);
  const [disapproveFormChangeLogRequest, setDisapproveFormChangeLogRequest] =
    useState(false);
  const [generalReasonForRejection, setGeneralReasonForRejection] =
    useState("");

  const [showViewOTApproverForm, setShowViewOTApproverForm] = useState(false);
  const [showViewLeaveApproverForm, setShowViewLeaveApproverForm] =
    useState(false);
  const [
    showViewChangeRequestApproverForm,
    setShowViewChangeRequestApproverForm,
  ] = useState(false);

  const [showUpdateOTForm, setShowUpdateOTForm] = useState(false);
  const [showUpdateLeaveForm, setShowUpdateLeaveForm] = useState(false);
  const [showUpdateChangeScheduleForm, setShowUpdateChangeScheduleForm] =
    useState(false);
  const [showUpdateChangeLogForm, setShowUpdateChangeLogForm] = useState(false);

  const [daysRange, setDaysRange] = useState(15);
  const [daysRangeTemp, setDaysRangeTemp] = useState(daysRange);

  const openUpdateFormOT = () => {
    setShowUpdateOTForm(true);
  };
  const closeUpdateFormOT = () => {
    setShowUpdateOTForm(false);
  };
  const openUpdateFormLeave = () => {
    setShowUpdateLeaveForm(true);
  };
  const closeUpdateFormLeave = () => {
    setShowUpdateLeaveForm(false);
  };
  const openUpdateFormChangeSchedule = () => {
    setShowUpdateChangeScheduleForm(true);
  };
  const closeUpdateFormChangeSchedule = () => {
    setShowUpdateChangeScheduleForm(false);
  };
  const openUpdateFormChangeLog = () => {
    setShowUpdateChangeLogForm(true);
  };
  const closeUpdateFormChangeLog = () => {
    setShowUpdateChangeLogForm(false);
  };

  const [approveMessage, setApproveMessage] = useState(false);
  const [disapproveMessage, setDisapproveMessage] = useState(false);
  const [cancelledMessage, setCancelledMessage] = useState(false);

  const [isChangeFilter, setIsChangeFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [isSelectAll, setIsSelectAll] = useState(false);
  const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs
  const [selected, setSelected] = useState([]); // Array to store active row IDs

  const triggerSelectAll = () => {
    if (requestApproval.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Wait for the requests to load.");
      return;
    }
    setIsSelectAll(true);
  };

  const [massApproveConfirmation, setMassApproveConfirmation] = useState(false); // Array to store active row IDs
  const [massDisapproveConfirmation, setMassDisapproveConfirmation] =
    useState(false); // Array to store active row IDs

  const openMassApproveConfirmation = () => {
    if (selected.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No selected requests.");
      return;
    }

    setMassApproveConfirmation(true);
  };
  const closeMassApproveConfirmation = () => {
    setMassApproveConfirmation(false);
  };
  const openMassDispproveConfirmation = () => {
    if (selected.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No selected requests.");
      return;
    }

    setMassDisapproveConfirmation(true);
  };
  const closeMassDisapproveConfirmation = () => {
    setMassDisapproveConfirmation(false);
  };

  const apiUrlApproverHierarchy = domain + "/api/ApproverHierarchy";
  const apiUrlLocationApproverHierarchy =
    domain + "/api/LocationApproverHierarchy";
  const overTimeApiUrl = domain + "/api/OvertimeRequest";
  const leaveTimeApiUrl = domain + "/api/LeaveRequest";
  const changeOfScheduleTimeApiUrl = domain + "/api/ChangeScheduleRequest";
  const changeLogRequestTimeApiUrl = domain + "/api/ChangeLogRequest";

  const fetchDataApprover = useCallback(
    async (data) => {
      try {
        const response = await axios.get(
          apiUrlApproverHierarchy + `/${data.employeePersonalInformationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );

        return response.data; // Return the response data
      } catch (error) {
        console.error("Error fetching data:", error);
        return []; // Return an empty array in case of error
      }
    },
    [apiUrlApproverHierarchy]
  );
  const fetchDataApproverAll = useCallback(async () => {
    try {
      const response = await axios.get(apiUrlApproverHierarchy, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return []; // Return an empty array in case of error
    }
  }, [apiUrlApproverHierarchy]);
  const fetchDataLocationApprover = useCallback(
    async (locationId) => {
      try {
        const response = await axios.get(
          apiUrlLocationApproverHierarchy + `/${locationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );

        return response.data; // Return the response data
      } catch (error) {
        console.error("Error fetching data:", error);
        return []; // Return an empty array in case of error
      }
    },
    [apiUrlLocationApproverHierarchy]
  );
  const fetchDataLocationApproverAll = useCallback(async () => {
    try {
      const response = await axios.get(apiUrlLocationApproverHierarchy, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return []; // Return an empty array in case of error
    }
  }, [apiUrlLocationApproverHierarchy]);
  const fetchDataEmployees = useCallback(async (data) => {
    const apiUrlEmployee = domain + "/api/Employee";

    try {
      const response = await axios.get(
        apiUrlEmployee + `/${data.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const fetchDataAllEmployees = useCallback(async () => {
    const apiUrlEmployee = domain + "/api/Employee";

    try {
      const response = await axios.get(apiUrlEmployee, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const fetchDataApproval = useCallback(async () => {
    const apiUrl = domain + "/api/Approval";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const fetchDataAccessTemplate = useCallback(async () => {
    const apiUrl = domain + "/api/AccessTemplate";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      return response.data; // Return the response data
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);

  const fetchData = useCallback(async () => {
    if (daysRange <= 0) {
      return;
    }
    setLoading(true);
    setRequestApproval([]);

    try {
      const apiUrl = domain + "/api/TransactionRequest";

      const response = await axios.get(
        `${apiUrl}/timeKeeper/${user.employeePersonalInformationId}/days/${daysRange}/ot-only`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const filteredMonthly = response.data.filter((item) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Normalize currentDate to midnight

        const pastDate = new Date(currentDate);
        pastDate.setDate(currentDate.getDate() - 30); // Set to mothly

        const requestDate = new Date(item.requestDate);
        requestDate.setHours(0, 0, 0, 0); // Normalize requestDate to midnight

        return requestDate >= pastDate && requestDate <= currentDate;
      });

      // Your existing logic for handling data
      if (filterDataIndex === 0) {
        setFilterData(filteredMonthly);
        setRequestApproval(filteredMonthly);
      } else if (filterDataIndex === 1) {
        const leaveItems = filteredMonthly.filter(
          (item) => item.requestTypeId === 1
        );
        setFilterData(leaveItems);
        setRequestApproval(leaveItems);
      } else if (filterDataIndex === 2) {
        const changeScheduleItems = filteredMonthly.filter(
          (item) => item.requestTypeId === 2
        );
        setFilterData(changeScheduleItems);
        setRequestApproval(changeScheduleItems);
      } else if (filterDataIndex === 3) {
        const overtimeRequestItems = filteredMonthly.filter(
          (item) => item.requestTypeId === 3
        );
        setFilterData(overtimeRequestItems);
        setRequestApproval(overtimeRequestItems);
      } else if (filterDataIndex === 4) {
        const changeLogRequestItems = filteredMonthly.filter(
          (item) => item.requestTypeId === 4
        );
        setFilterData(changeLogRequestItems);
        setRequestApproval(changeLogRequestItems);
      } else if (filterDataIndex === 5) {
        setFilterData(filteredMonthly);
        setRequestApproval(filteredMonthly);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [filterDataIndex, daysRange, user]);

  const fetchOTRequestData = useCallback(async () => {}, []);
  const fetchLeaveRequestData = useCallback(async () => {}, []);
  const fetchChangeOfScheduleRequestData = useCallback(async () => {}, []);
  const fetchChangeLogRequestData = useCallback(async () => {}, []);

  useEffect(() => {
    if (userAccess.description === "HR Head") {
      setIsHRHead(true);
      // fetchDataHR();
    } else {
      setIsHRHead(false);
    }
    fetchData();
  }, [
    fetchData,
    // fetchDataHR,
    filterDataIndex2,
    userAccess,
  ]);

  useEffect(() => {
    fetchOTRequestData();
    fetchLeaveRequestData();
    fetchChangeOfScheduleRequestData();
    fetchChangeLogRequestData();
  }, [
    fetchOTRequestData,
    fetchLeaveRequestData,
    fetchChangeOfScheduleRequestData,
    fetchChangeLogRequestData,
  ]);

  useEffect(() => {
    if (approveMessage) {
      const timeoutId = setTimeout(() => {
        setApproveMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [approveMessage]);
  useEffect(() => {
    if (disapproveMessage) {
      const timeoutId = setTimeout(() => {
        setDisapproveMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [disapproveMessage]);
  useEffect(() => {
    if (cancelledMessage) {
      const timeoutId = setTimeout(() => {
        setCancelledMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [cancelledMessage]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    var res = filterData.filter((f) =>
      f.employeeId.toString().startsWith(value)
    );

    setRequestApproval(res);
  };
  const handleFilterForOvertimeList = (value) => {
    if (overtimeRequestDataForOvertimeList.length <= 0) {
      return;
    }

    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndexForOvertimeList) {
      case 0:
        res = filterDataForOvertimeList.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterDataForOvertimeList.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 2:
        res = filterDataForOvertimeList.filter((f) =>
          f.employeePersonalInformationId.toString().startsWith(value)
        );
        break;
      default:
        res = filterDataForOvertimeList.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );

        break;
    }

    setOvertimeRequestDataForOvertimeList(res);
  };
  const updateApprovals = async (event, updateStatus) => {
    event.preventDefault();

    setLoadingRequest(true);

    const accessTemplate = await fetchDataAccessTemplate();
    const userAccess = accessTemplate.find(
      (access) => access.id === user.accessTemplateId
    );

    const employees = await fetchDataEmployees(editData);
    const foundEmployeeInfo = employees;

    if (userAccess.description === "HR Head") {
      // handleOTUpdateHoursFirst(event, updateStatus);
      handleStatus(event, updateStatus);

      await sendSms(editData, updateStatus, foundEmployeeInfo);

      setEditData("");
      setLoadingRequest(false);

      await fetchData();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();
      return;
    }

    const approvals = await fetchDataApproval();

    const apiUrl = domain + "/api/Approval";

    const trackApproval = approvals.find(
      (approval) =>
        approval.requestId.toString() === editData.id.toString() &&
        approval.requestTypeId.toString() === editData.requestTypeId.toString()
    );

    const approverData = await fetchDataApprover(editData);
    let locationApprover = [];
    let approverType = "";
    let isApproverByLocation = false;

    const filteredData = approverData;

    if (filteredData.primaryApprover) {
      if (
        filteredData.primaryApprover.primaryApprover1Id ===
          user.employeePersonalInformationId ||
        filteredData.primaryApprover.primaryApprover2Id ===
          user.employeePersonalInformationId ||
        filteredData.primaryApprover.primaryApprover3Id ===
          user.employeePersonalInformationId ||
        filteredData.primaryApprover.primaryApprover4Id ===
          user.employeePersonalInformationId
      ) {
        approverType = "Primary";
      }
    }

    if (filteredData.secondaryApprover) {
      if (
        filteredData.secondaryApprover.secondaryApprover1Id ===
          user.employeePersonalInformationId ||
        filteredData.secondaryApprover.secondaryApprover2Id ===
          user.employeePersonalInformationId ||
        filteredData.secondaryApprover.secondaryApprover3Id ===
          user.employeePersonalInformationId ||
        filteredData.secondaryApprover.secondaryApprover4Id ===
          user.employeePersonalInformationId
      ) {
        approverType = "Secondary";
      }
    }

    if (filteredData.tertiaryApprover) {
      if (
        filteredData.tertiaryApprover.tertiaryApprover1Id ===
          user.employeePersonalInformationId ||
        filteredData.tertiaryApprover.tertiaryApprover2Id ===
          user.employeePersonalInformationId ||
        filteredData.tertiaryApprover.tertiaryApprover3Id ===
          user.employeePersonalInformationId ||
        filteredData.tertiaryApprover.tertiaryApprover4Id ===
          user.employeePersonalInformationId
      ) {
        approverType = "Tertiary";
      }
    }

    const isEmpty = (value) => {
      if (
        value === 0 ||
        value === "" ||
        value === null ||
        value === undefined
      ) {
        return true;
      }

      return false;
    };

    if (!approverType) {
      const locationId = foundEmployeeInfo.employeeInformation.locationId;
      locationApprover = await fetchDataLocationApprover(locationId);

      if (locationApprover.primaryApprovers) {
        if (
          (locationApprover.primaryApprovers[0] &&
            locationApprover.primaryApprovers[0].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.primaryApprovers[1] &&
            locationApprover.primaryApprovers[1].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.primaryApprovers[2] &&
            locationApprover.primaryApprovers[2].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.primaryApprovers[3] &&
            locationApprover.primaryApprovers[3].approverId ===
              user.employeePersonalInformationId)
        ) {
          approverType = "Primary";
        }
      }

      if (locationApprover.secondaryApprovers) {
        if (
          (locationApprover.secondaryApprovers[0] &&
            locationApprover.secondaryApprovers[0].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.secondaryApprovers[1] &&
            locationApprover.secondaryApprovers[1].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.secondaryApprovers[2] &&
            locationApprover.secondaryApprovers[2].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.secondaryApprovers[3] &&
            locationApprover.secondaryApprovers[3].approverId ===
              user.employeePersonalInformationId)
        ) {
          approverType = "Secondary";
        }
      }

      if (locationApprover.tertiaryApprovers) {
        if (
          (locationApprover.tertiaryApprovers[0] &&
            locationApprover.tertiaryApprovers[0].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.tertiaryApprovers[1] &&
            locationApprover.tertiaryApprovers[1].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.tertiaryApprovers[2] &&
            locationApprover.tertiaryApprovers[2].approverId ===
              user.employeePersonalInformationId) ||
          (locationApprover.tertiaryApprovers[3] &&
            locationApprover.tertiaryApprovers[3].approverId ===
              user.employeePersonalInformationId)
        ) {
          approverType = "Tertiary";
        }
      }

      isApproverByLocation = true;
    }

    if (approverType === "Primary") {
      if (
        trackApproval &&
        (trackApproval.primaryApproverStatus === "Approved" ||
          trackApproval.primaryApproverStatus === "Disapproved")
      ) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage(
          `Already approved/disapproved by ${trackApproval.primaryApproverFullName}`
        );
        setLoadingRequest(false);
        return;
      }
    } else if (approverType === "Secondary") {
      if (
        trackApproval &&
        (trackApproval.secondaryApproverStatus === "Approved" ||
          trackApproval.secondaryApproverStatus === "Disapproved")
      ) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage(
          `Already approved/disapproved by ${trackApproval.secondaryApproverFullName}`
        );
        setLoadingRequest(false);
        return;
      }
    } else if (approverType === "Tertiary") {
      if (
        trackApproval &&
        (trackApproval.tertiaryApproverStatus === "Approved" ||
          trackApproval.tertiaryApproverStatus === "Disapproved")
      ) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage(
          `Already approved/disapproved by ${trackApproval.tertiaryApproverFullName}`
        );
        setLoadingRequest(false);
        return;
      }
    }

    const data = {
      requestId: editData.id,
      requestTypeId: editData.requestTypeId,
      // ================================
      // ================================
      primaryApproverId:
        trackApproval && !isEmpty(trackApproval.primaryApproverId)
          ? trackApproval.primaryApproverId
          : approverType === "Primary"
          ? user.employeePersonalInformationId
          : null,
      primaryApproverUpdateDate:
        trackApproval && !isEmpty(trackApproval.primaryApproverId)
          ? trackApproval.primaryApproverUpdateDate
          : approverType === "Primary"
          ? new Date()
          : null,
      primaryApproverStatus:
        trackApproval && !isEmpty(trackApproval.primaryApproverId)
          ? trackApproval.primaryApproverStatus
          : approverType === "Primary"
          ? updateStatus
          : approverType === "Secondary" || approverType === "Tertiary"
          ? updateStatus
          : "",
      // ================================
      // ================================
      secondaryApproverId:
        trackApproval && !isEmpty(trackApproval.secondaryApproverId)
          ? trackApproval.secondaryApproverId
          : approverType === "Secondary"
          ? user.employeePersonalInformationId
          : null,
      secondaryApproverUpdateDate:
        trackApproval && !isEmpty(trackApproval.secondaryApproverId)
          ? trackApproval.secondaryApproverUpdateDate
          : approverType === "Secondary"
          ? new Date()
          : null,
      secondaryApproverStatus:
        trackApproval && !isEmpty(trackApproval.secondaryApproverId)
          ? trackApproval.secondaryApproverStatus
          : approverType === "Secondary"
          ? updateStatus
          : approverType === "Tertiary"
          ? updateStatus
          : "",
      // ================================
      // ================================
      tertiaryApproverId:
        trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
          ? trackApproval.tertiaryApproverId
          : approverType === "Tertiary"
          ? user.employeePersonalInformationId
          : null,
      tertiaryApproverUpdateDate:
        trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
          ? trackApproval.tertiaryApproverUpdateDate
          : approverType === "Tertiary"
          ? new Date()
          : null,
      tertiaryApproverStatus:
        trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
          ? trackApproval.tertiaryApproverStatus
          : approverType === "Tertiary"
          ? updateStatus
          : "",
    };

    try {
      await axios.post(
        apiUrl + `/${trackApproval ? trackApproval.id : 0}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Data updated successfully");

      // Reload table data and reset form fields
      /* if(userAccess.description === "HR Head"){
                fetchDataHR();
            } else {
                fetchData();
            }
            await fetchOTRequestData();
            await fetchLeaveRequestData();
            await fetchChangeOfScheduleRequestData(); 
            await fetchChangeLogRequestData();  */

      if (requestType === "Leave Request") {
        updateStatus === "Approved"
          ? setApproveFormLeave(false)
          : setDisapproveFormLeave(false);
      }
      if (requestType === "Change Schedule") {
        updateStatus === "Approved"
          ? setApproveFormChangeSchedule(false)
          : setDisapproveFormChangeSchedule(false);
      }
      if (requestType === "Overtime Request") {
        updateStatus === "Approved"
          ? setApproveFormOT(false)
          : setDisapproveFormOT(false);
      }
      if (requestType === "Change Log Request") {
        updateStatus === "Approved"
          ? setApproveFormChangeLogRequest(false)
          : setDisapproveFormChangeLogRequest(false);
      }

      // await sendSms(editData, updateStatus, foundEmployeeInfo.mobileNumber);

      await sendSms(editData, updateStatus, foundEmployeeInfo);
      // setEditData("");
      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    }

    let approverPerSelectedEmployee = approverData;

    let hasPrimary = false;
    let hasSecondary = false;
    let hasTertiary = false;

    if (isApproverByLocation) {
      approverPerSelectedEmployee = locationApprover;

      if (approverPerSelectedEmployee) {
        if (approverPerSelectedEmployee.primaryApprovers) {
          if (
            (approverPerSelectedEmployee.primaryApprovers[0] &&
              !isEmpty(
                approverPerSelectedEmployee.primaryApprovers[0].approverId
              )) ||
            (approverPerSelectedEmployee.primaryApprovers[1] &&
              !isEmpty(
                approverPerSelectedEmployee.primaryApprovers[1].approverId
              )) ||
            (approverPerSelectedEmployee.primaryApprovers[2] &&
              !isEmpty(
                approverPerSelectedEmployee.primaryApprovers[2].approverId
              )) ||
            (approverPerSelectedEmployee.primaryApprovers[3] &&
              !isEmpty(
                approverPerSelectedEmployee.primaryApprovers[3].approverId
              ))
          ) {
            hasPrimary = true;
          }
        }
        if (approverPerSelectedEmployee.secondaryApprovers) {
          if (
            (approverPerSelectedEmployee.secondaryApprovers[0] &&
              !isEmpty(
                approverPerSelectedEmployee.secondaryApprovers[0].approverId
              )) ||
            (approverPerSelectedEmployee.secondaryApprovers[1] &&
              !isEmpty(
                approverPerSelectedEmployee.secondaryApprovers[1].approverId
              )) ||
            (approverPerSelectedEmployee.secondaryApprovers[2] &&
              !isEmpty(
                approverPerSelectedEmployee.secondaryApprovers[2].approverId
              )) ||
            (approverPerSelectedEmployee.secondaryApprovers[3] &&
              !isEmpty(
                approverPerSelectedEmployee.secondaryApprovers[3].approverId
              ))
          ) {
            hasSecondary = true;
          }
        }
        if (approverPerSelectedEmployee.tertiaryApprovers) {
          if (
            (approverPerSelectedEmployee.tertiaryApprovers[0] &&
              !isEmpty(
                approverPerSelectedEmployee.tertiaryApprovers[0].approverId
              )) ||
            (approverPerSelectedEmployee.tertiaryApprovers[1] &&
              !isEmpty(
                approverPerSelectedEmployee.tertiaryApprovers[1].approverId
              )) ||
            (approverPerSelectedEmployee.tertiaryApprovers[2] &&
              !isEmpty(
                approverPerSelectedEmployee.tertiaryApprovers[2].approverId
              )) ||
            (approverPerSelectedEmployee.tertiaryApprovers[3] &&
              !isEmpty(
                approverPerSelectedEmployee.tertiaryApprovers[3].approverId
              ))
          ) {
            hasTertiary = true;
          }
        }
      }
    } else {
      if (approverPerSelectedEmployee) {
        if (approverPerSelectedEmployee.primaryApprover) {
          if (
            !isEmpty(
              approverPerSelectedEmployee.primaryApprover.primaryApprover1Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.primaryApprover.primaryApprover2Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.primaryApprover.primaryApprover3Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.primaryApprover.primaryApprover4Id
            )
          ) {
            hasPrimary = true;
          }
        }
        if (approverPerSelectedEmployee.secondaryApprover) {
          if (
            !isEmpty(
              approverPerSelectedEmployee.secondaryApprover.secondaryApprover1Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.secondaryApprover.secondaryApprover2Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.secondaryApprover.secondaryApprover3Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.secondaryApprover.secondaryApprover4Id
            )
          ) {
            hasSecondary = true;
          }
        }
        if (approverPerSelectedEmployee.tertiaryApprover) {
          if (
            !isEmpty(
              approverPerSelectedEmployee.tertiaryApprover.tertiaryApprover1Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.tertiaryApprover.tertiaryApprover2Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.tertiaryApprover.tertiaryApprover3Id
            ) ||
            !isEmpty(
              approverPerSelectedEmployee.tertiaryApprover.tertiaryApprover4Id
            )
          ) {
            hasTertiary = true;
          }
        }
      }
    }

    if (hasTertiary) {
      if (approverType === "Tertiary") {
        //update
        await handleStatus(event, updateStatus);
      }
    } else if (!hasTertiary && hasSecondary) {
      if (approverType === "Secondary") {
        //update
        await handleStatus(event, updateStatus);
      }
    } else if (!hasTertiary && !hasSecondary && hasPrimary) {
      if (approverType === "Primary") {
        //update
        await handleStatus(event, updateStatus);
      }
    }

    unselectAll();

    await fetchData();
    await fetchOTRequestData();
    await fetchLeaveRequestData();
    await fetchChangeOfScheduleRequestData();
    await fetchChangeLogRequestData();

    setEditData("");
    setLoadingRequest(false);
  };
  const handleStatus = async (event, updateStatus) => {
    event.preventDefault();

    setLoadingRequest(true);

    var requestUrl = overTimeApiUrl;

    if (requestType === "Leave Request") {
      requestUrl = leaveTimeApiUrl;
    }

    if (requestType === "Change Schedule") {
      requestUrl = changeOfScheduleTimeApiUrl;
    }

    if (requestType === "Overtime Request") {
      requestUrl = overTimeApiUrl;
      await handleOTUpdateHoursFirst(event, updateStatus);
    }

    if (requestType === "Change Log Request") {
      requestUrl = changeLogRequestTimeApiUrl;
    }

    const data = {
      id: editData.id,
      approverId: user.employeePersonalInformationId, //temporary
      status: updateStatus,
      reasonForRejection:
        updateStatus === "Approved"
          ? editData.editReasonForRejection
          : generalReasonForRejection,
    };

    try {
      await axios.put(requestUrl + "/status", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      // Reload table data and reset form fields
      /* if(userAccess.description === "HR Head"){
                fetchDataHR();
            } else {
                fetchData();
            }
            fetchOTRequestData();
            fetchLeaveRequestData();
            fetchChangeOfScheduleRequestData(); 
            fetchChangeLogRequestData(); 
            setEditData(""); */

      if (requestType === "Leave Request") {
        updateStatus === "Approved"
          ? setApproveFormLeave(false)
          : setDisapproveFormLeave(false);
      }
      if (requestType === "Change Schedule") {
        updateStatus === "Approved"
          ? setApproveFormChangeSchedule(false)
          : setDisapproveFormChangeSchedule(false);
      }
      if (requestType === "Overtime Request") {
        updateStatus === "Approved"
          ? setApproveFormOT(false)
          : setDisapproveFormOT(false);
      }
      if (requestType === "Change Log Request") {
        updateStatus === "Approved"
          ? setApproveFormChangeLogRequest(false)
          : setDisapproveFormChangeLogRequest(false);
      }

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
    if (requestType === "Leave Request") {
      updateStatus === "Approved"
        ? setApproveFormLeave(false)
        : setDisapproveFormLeave(false);
    }
    if (requestType === "Change Schedule") {
      updateStatus === "Approved"
        ? setApproveFormChangeSchedule(false)
        : setDisapproveFormChangeSchedule(false);
    }
    if (requestType === "Overtime Request") {
      updateStatus === "Approved"
        ? setApproveFormOT(false)
        : setDisapproveFormOT(false);
    }
    if (requestType === "Change Log Request") {
      updateStatus === "Approved"
        ? setApproveFormChangeLogRequest(false)
        : setDisapproveFormChangeLogRequest(false);
    }
  };
  const handleOTUpdateHoursFirst = async (event, updateStatus) => {
    event.preventDefault();

    const data = {
      referenceNumber: editData.referenceNumber,
      employeePersonalInformationId: editData.employeePersonalInformationId,
      approverId: user.employeePersonalInformationId,
      requestTypeId: editData.requestTypeId,
      reason: editData.reason,
      reasonForRejection: editData.reasonForRejection,
      status: editData.status,
      dateRequested: editData.dateRequested,
      dateCompleted: editData.dateCompleted,
      date: editData.date,
      hours: hours,
      overtimeType: editData.overtimeType,
      hasOvertimeAllowance: editData.hasOvertimeAllowance,
      isAboveTwoHoursOvertime: editData.isAboveTwoHoursOvertime,
    };

    try {
      await axios.put(overTimeApiUrl + `/${editData.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");
    } catch (error) {
      setLoadingRequest(false);
      console.error("There was a problem updating data:", error);
    }
  };
  const handleOTUpdateDetails = async (event) => {
    event.preventDefault();

    if (
      !date ||
      !employeePersonalInformationId ||
      !approverIdOT ||
      !dateRequested ||
      !dateCompleted
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      referenceNumber: referenceNumber,
      employeePersonalInformationId: employeePersonalInformationId,
      approverId: approverIdOT,
      requestTypeId: requestTypeId,
      reason: reason,
      reasonForRejection: reasonForRejection,
      status: statusOT,
      dateRequested: dateRequested,
      dateCompleted: dateCompleted,
      date: date,
      hours: hours,
      overtimeType: overtimeType,
      hasOvertimeAllowance: hasOvertimeAllowance,
      isAboveTwoHoursOvertime: isAboveTwoHoursOvertime,
    };

    try {
      setLoadingRequest(true);
      await axios.put(overTimeApiUrl + `/${viewById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      await fetchData();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleLeaveUpdateDetails = async (event) => {
    event.preventDefault();

    if (
      !dateFromLeave ||
      !dateToLeave ||
      !approverIdLeave ||
      !daysLeave ||
      !dateRequestedLeave ||
      !dateCompletedLeave
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      referenceNumber: referenceNumberLeave,
      employeePersonalInformationId: employeePersonalInformationIdLeave,
      approverId: approverIdLeave,
      requestTypeId: requestTypeIdLeave,
      reason: reasonLeave,
      reasonForRejection: reasonForRejectionLeave,
      status: statusLeave,
      dateRequested: dateRequestedLeave,
      dateCompleted: dateCompletedLeave,
      dateFrom: dateFromLeave,
      dateTo: dateToLeave,
      leaveTypeId: leaveType,
      days: daysLeave,
      isHalfDay: isHalfDayLeave,
    };

    try {
      setLoadingRequest(true);
      await axios.put(leaveTimeApiUrl + `/${viewById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      await fetchData();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleChangeScheduleUpdateDetails = async (event) => {
    event.preventDefault();

    if (
      !dateFromChangeSchedule ||
      !dateToChangeSchedule ||
      !shiftScheduleFromId ||
      !shiftScheduleToId ||
      !dateRequestedChangeSchedule ||
      !dateCompletedChangeSchedule
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      referenceNumber: referenceNumberChangeSchedule,
      employeePersonalInformationId:
        employeePersonalInformationIdChangeSchedule,
      approverId: approverIdChangeSchedule,
      requestTypeId: requestTypeIdChangeSchedule,
      reason: reasonChangeSchedule,
      reasonForRejection: reasonForRejectionChangeSchedule,
      status: statusChangeSchedule,
      dateRequested: dateRequestedChangeSchedule,
      dateCompleted: dateCompletedChangeSchedule,
      dateFrom: dateFromChangeSchedule,
      dateTo: dateToChangeSchedule,
      shiftScheduleFromId: shiftScheduleFromId,
      shiftScheduleToId: shiftScheduleToId,
    };

    try {
      setLoadingRequest(true);
      await axios.put(changeOfScheduleTimeApiUrl + `/${viewById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      await fetchData();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleChangeLogRequestUpdateDetails = async (event) => {
    event.preventDefault();

    if (
      !timeTypeChangeLogRequest ||
      !dateChangeLogRequest ||
      !timeRequestedChangeLogRequest
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      referenceNumber: referenceNumberChangeLog,
      employeePersonalInformationId:
        employeePersonalInformationIdChangeLogRequest,
      reason: reasonChangeLogRequest,
      reasonForRejection: reasonForRejectionChangeLogRequest,
      status: statusChangeLogRequest,
      date: dateChangeLogRequest,
      timeType: timeTypeChangeLogRequest,
      timeRendered: timeRequestedChangeLogRequest,
    };

    try {
      setLoadingRequest(true);
      await axios.put(changeLogRequestTimeApiUrl + `/${viewById}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      await fetchData();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const handleGenerate = () => {
    if (!downloadDate) {
      setErrorState(true);
      return;
    }

    setErrorState(false);
    setIsGenerate(true);
  };
  const handleConfirmationApproveFromOvertimeList = () => {
    if (selectedToAdd.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No records to approve");
      return;
    }

    setApproveConfirmation(true);
  };
  const handleApproveAllSelected = async (event) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrl = domain + "/api/OvertimeRequest/status";

    try {
      const approvePromises = [];

      selectedToAdd.forEach((entry) => {
        const data = {
          id: entry.id,
          approverId: user.employeePersonalInformationId, //temporary
          status: "Approved",
        };

        const approvePromise = axios.put(apiUrl, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        approvePromises.push(approvePromise);
      });

      await Promise.all(approvePromises);

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request approved");

      closeConfirmationHandleClick();
      setIsGenerate(true);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "An error occurred.";
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const updateApprovalsBulk = async (event, updateStatus) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrl = domain + "/api/Approval/bulk";

    const employees = await fetchDataAllEmployees();
    const approvals = await fetchDataApproval();
    const approverDatas = await fetchDataApproverAll();
    const locationApprovers = await fetchDataLocationApproverAll();

    let finalData = [];
    let finalDataBulk = [];

    let errorItem = [];

    for (const item of selected) {
      if (userAccess.description === "HR Head") {
        finalDataBulk.push(item);

        if (item.status === "Approved" || item.status === "Disapproved") {
          errorItem.push(item.formattedReferenceNumber);
        }
      } else {
        // Await the async function call
        const foundEmployeeInfo = employees.find(
          (employee) => employee.employeeId === item.employeeId
        );

        const trackApproval = approvals.find(
          (approval) =>
            approval.requestId.toString() === item.id.toString() &&
            approval.requestTypeId.toString() === item.requestTypeId.toString()
        );

        const approverData = approverDatas.find(
          (data) => data.employeePersonalInformationId === foundEmployeeInfo.id
        );

        let locationApprover = [];
        let approverType = "";
        let isApproverByLocation = false;

        const filteredData = approverData;

        if (filteredData.primaryApprover) {
          if (
            filteredData.primaryApprover.primaryApprover1Id ===
              user.employeePersonalInformationId ||
            filteredData.primaryApprover.primaryApprover2Id ===
              user.employeePersonalInformationId ||
            filteredData.primaryApprover.primaryApprover3Id ===
              user.employeePersonalInformationId ||
            filteredData.primaryApprover.primaryApprover4Id ===
              user.employeePersonalInformationId
          ) {
            approverType = "Primary";
          }
        }

        if (filteredData.secondaryApprover) {
          if (
            filteredData.secondaryApprover.secondaryApprover1Id ===
              user.employeePersonalInformationId ||
            filteredData.secondaryApprover.secondaryApprover2Id ===
              user.employeePersonalInformationId ||
            filteredData.secondaryApprover.secondaryApprover3Id ===
              user.employeePersonalInformationId ||
            filteredData.secondaryApprover.secondaryApprover4Id ===
              user.employeePersonalInformationId
          ) {
            approverType = "Secondary";
          }
        }

        if (filteredData.tertiaryApprover) {
          if (
            filteredData.tertiaryApprover.tertiaryApprover1Id ===
              user.employeePersonalInformationId ||
            filteredData.tertiaryApprover.tertiaryApprover2Id ===
              user.employeePersonalInformationId ||
            filteredData.tertiaryApprover.tertiaryApprover3Id ===
              user.employeePersonalInformationId ||
            filteredData.tertiaryApprover.tertiaryApprover4Id ===
              user.employeePersonalInformationId
          ) {
            approverType = "Tertiary";
          }
        }

        const isEmpty = (value) => {
          if (
            value === 0 ||
            value === "" ||
            value === null ||
            value === undefined
          ) {
            return true;
          }

          return false;
        };

        if (!approverType) {
          const locationId = foundEmployeeInfo.employeeInformation.locationId;
          locationApprover = locationApprovers.find(
            (approver) => approver.locationId === locationId
          );

          if (locationApprover.primaryApprovers) {
            if (
              (locationApprover.primaryApprovers[0] &&
                locationApprover.primaryApprovers[0].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.primaryApprovers[1] &&
                locationApprover.primaryApprovers[1].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.primaryApprovers[2] &&
                locationApprover.primaryApprovers[2].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.primaryApprovers[3] &&
                locationApprover.primaryApprovers[3].approverId ===
                  user.employeePersonalInformationId)
            ) {
              approverType = "Primary";
            }
          }

          if (locationApprover.secondaryApprovers) {
            if (
              (locationApprover.secondaryApprovers[0] &&
                locationApprover.secondaryApprovers[0].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.secondaryApprovers[1] &&
                locationApprover.secondaryApprovers[1].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.secondaryApprovers[2] &&
                locationApprover.secondaryApprovers[2].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.secondaryApprovers[3] &&
                locationApprover.secondaryApprovers[3].approverId ===
                  user.employeePersonalInformationId)
            ) {
              approverType = "Secondary";
            }
          }

          if (locationApprover.tertiaryApprovers) {
            if (
              (locationApprover.tertiaryApprovers[0] &&
                locationApprover.tertiaryApprovers[0].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.tertiaryApprovers[1] &&
                locationApprover.tertiaryApprovers[1].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.tertiaryApprovers[2] &&
                locationApprover.tertiaryApprovers[2].approverId ===
                  user.employeePersonalInformationId) ||
              (locationApprover.tertiaryApprovers[3] &&
                locationApprover.tertiaryApprovers[3].approverId ===
                  user.employeePersonalInformationId)
            ) {
              approverType = "Tertiary";
            }
          }

          isApproverByLocation = true;
        }

        if (approverType === "Primary") {
          if (
            trackApproval &&
            (trackApproval.primaryApproverStatus === "Approved" ||
              trackApproval.primaryApproverStatus === "Disapproved")
          ) {
            errorItem.push(item.formattedReferenceNumber);
          }
        } else if (approverType === "Secondary") {
          if (
            trackApproval &&
            (trackApproval.secondaryApproverStatus === "Approved" ||
              trackApproval.secondaryApproverStatus === "Disapproved")
          ) {
            errorItem.push(item.formattedReferenceNumber);
          }
        } else if (approverType === "Tertiary") {
          if (
            trackApproval &&
            (trackApproval.tertiaryApproverStatus === "Approved" ||
              trackApproval.tertiaryApproverStatus === "Disapproved")
          ) {
            errorItem.push(item.formattedReferenceNumber);
          }
        }

        const data = {
          ...(trackApproval ? { id: trackApproval.id } : {}),
          requestId: item.id,
          requestTypeId: item.requestTypeId,
          // ================================
          // ================================
          primaryApproverId:
            trackApproval && !isEmpty(trackApproval.primaryApproverId)
              ? trackApproval.primaryApproverId
              : approverType === "Primary"
              ? user.employeePersonalInformationId
              : null,
          primaryApproverUpdateDate:
            trackApproval && !isEmpty(trackApproval.primaryApproverId)
              ? trackApproval.primaryApproverUpdateDate
              : approverType === "Primary"
              ? new Date()
              : null,
          primaryApproverStatus:
            trackApproval && !isEmpty(trackApproval.primaryApproverId)
              ? trackApproval.primaryApproverStatus
              : approverType === "Primary"
              ? updateStatus
              : approverType === "Secondary" || approverType === "Tertiary"
              ? updateStatus
              : "",
          // ================================
          // ================================
          secondaryApproverId:
            trackApproval && !isEmpty(trackApproval.secondaryApproverId)
              ? trackApproval.secondaryApproverId
              : approverType === "Secondary"
              ? user.employeePersonalInformationId
              : null,
          secondaryApproverUpdateDate:
            trackApproval && !isEmpty(trackApproval.secondaryApproverId)
              ? trackApproval.secondaryApproverUpdateDate
              : approverType === "Secondary"
              ? new Date()
              : null,
          secondaryApproverStatus:
            trackApproval && !isEmpty(trackApproval.secondaryApproverId)
              ? trackApproval.secondaryApproverStatus
              : approverType === "Secondary"
              ? updateStatus
              : approverType === "Tertiary"
              ? updateStatus
              : "",
          // ================================
          // ================================
          tertiaryApproverId:
            trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
              ? trackApproval.tertiaryApproverId
              : approverType === "Tertiary"
              ? user.employeePersonalInformationId
              : null,
          tertiaryApproverUpdateDate:
            trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
              ? trackApproval.tertiaryApproverUpdateDate
              : approverType === "Tertiary"
              ? new Date()
              : null,
          tertiaryApproverStatus:
            trackApproval && !isEmpty(trackApproval.tertiaryApproverId)
              ? trackApproval.tertiaryApproverStatus
              : approverType === "Tertiary"
              ? updateStatus
              : "",
        };

        finalData.push(data);

        let approverPerSelectedEmployee = approverData;

        let hasPrimary = false;
        let hasSecondary = false;
        let hasTertiary = false;

        if (isApproverByLocation) {
          approverPerSelectedEmployee = locationApprover;

          if (approverPerSelectedEmployee) {
            if (approverPerSelectedEmployee.primaryApprovers) {
              if (
                (approverPerSelectedEmployee.primaryApprovers[0] &&
                  !isEmpty(
                    approverPerSelectedEmployee.primaryApprovers[0].approverId
                  )) ||
                (approverPerSelectedEmployee.primaryApprovers[1] &&
                  !isEmpty(
                    approverPerSelectedEmployee.primaryApprovers[1].approverId
                  )) ||
                (approverPerSelectedEmployee.primaryApprovers[2] &&
                  !isEmpty(
                    approverPerSelectedEmployee.primaryApprovers[2].approverId
                  )) ||
                (approverPerSelectedEmployee.primaryApprovers[3] &&
                  !isEmpty(
                    approverPerSelectedEmployee.primaryApprovers[3].approverId
                  ))
              ) {
                hasPrimary = true;
              }
            }
            if (approverPerSelectedEmployee.secondaryApprovers) {
              if (
                (approverPerSelectedEmployee.secondaryApprovers[0] &&
                  !isEmpty(
                    approverPerSelectedEmployee.secondaryApprovers[0].approverId
                  )) ||
                (approverPerSelectedEmployee.secondaryApprovers[1] &&
                  !isEmpty(
                    approverPerSelectedEmployee.secondaryApprovers[1].approverId
                  )) ||
                (approverPerSelectedEmployee.secondaryApprovers[2] &&
                  !isEmpty(
                    approverPerSelectedEmployee.secondaryApprovers[2].approverId
                  )) ||
                (approverPerSelectedEmployee.secondaryApprovers[3] &&
                  !isEmpty(
                    approverPerSelectedEmployee.secondaryApprovers[3].approverId
                  ))
              ) {
                hasSecondary = true;
              }
            }
            if (approverPerSelectedEmployee.tertiaryApprovers) {
              if (
                (approverPerSelectedEmployee.tertiaryApprovers[0] &&
                  !isEmpty(
                    approverPerSelectedEmployee.tertiaryApprovers[0].approverId
                  )) ||
                (approverPerSelectedEmployee.tertiaryApprovers[1] &&
                  !isEmpty(
                    approverPerSelectedEmployee.tertiaryApprovers[1].approverId
                  )) ||
                (approverPerSelectedEmployee.tertiaryApprovers[2] &&
                  !isEmpty(
                    approverPerSelectedEmployee.tertiaryApprovers[2].approverId
                  )) ||
                (approverPerSelectedEmployee.tertiaryApprovers[3] &&
                  !isEmpty(
                    approverPerSelectedEmployee.tertiaryApprovers[3].approverId
                  ))
              ) {
                hasTertiary = true;
              }
            }
          }
        } else {
          if (approverPerSelectedEmployee) {
            if (approverPerSelectedEmployee.primaryApprover) {
              if (
                !isEmpty(
                  approverPerSelectedEmployee.primaryApprover.primaryApprover1Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.primaryApprover.primaryApprover2Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.primaryApprover.primaryApprover3Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.primaryApprover.primaryApprover4Id
                )
              ) {
                hasPrimary = true;
              }
            }
            if (approverPerSelectedEmployee.secondaryApprover) {
              if (
                !isEmpty(
                  approverPerSelectedEmployee.secondaryApprover
                    .secondaryApprover1Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.secondaryApprover
                    .secondaryApprover2Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.secondaryApprover
                    .secondaryApprover3Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.secondaryApprover
                    .secondaryApprover4Id
                )
              ) {
                hasSecondary = true;
              }
            }
            if (approverPerSelectedEmployee.tertiaryApprover) {
              if (
                !isEmpty(
                  approverPerSelectedEmployee.tertiaryApprover
                    .tertiaryApprover1Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.tertiaryApprover
                    .tertiaryApprover2Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.tertiaryApprover
                    .tertiaryApprover3Id
                ) ||
                !isEmpty(
                  approverPerSelectedEmployee.tertiaryApprover
                    .tertiaryApprover4Id
                )
              ) {
                hasTertiary = true;
              }
            }
          }
        }

        if (hasTertiary) {
          if (approverType === "Tertiary") {
            finalDataBulk.push(item);
          }
        } else if (!hasTertiary && hasSecondary) {
          if (approverType === "Secondary") {
            finalDataBulk.push(item);
          }
        } else if (!hasTertiary && !hasSecondary && hasPrimary) {
          if (approverType === "Primary") {
            finalDataBulk.push(item);
          }
        }
      }
    }

    if (errorItem.length > 0) {
      const errorItemsString = errorItem.join(", ");

      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage(
        `${errorItemsString} is/are already approved/disapproved.`
      );
      setLoadingRequest(false);
      return;
    }

    if (userAccess.description === "HR Head") {
      await handleStatusBulk(event, finalDataBulk, updateStatus);

      unselectAll();

      // await fetchDataHR();
      await fetchOTRequestData();
      await fetchLeaveRequestData();
      await fetchChangeOfScheduleRequestData();
      await fetchChangeLogRequestData();

      setEditData("");
      setLoadingRequest(false);
      closeMassApproveConfirmation();
      closeMassDisapproveConfirmation();
      return;
    }

    try {
      await axios.post(apiUrl, finalData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      // Reload table data and reset form fields
      /* if(userAccess.description === "HR Head"){
                await fetchDataHR();
            } else {
                await fetchData();
            }
            await fetchOTRequestData();
            await fetchLeaveRequestData();
            await fetchChangeOfScheduleRequestData(); 
            await fetchChangeLogRequestData();  */

      // await sendSms(editData, updateStatus, foundEmployeeInfo)
      // setEditData("");
      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    }

    //Leave
    if (finalDataBulk.length > 0) {
      await handleStatusBulk(event, finalDataBulk, updateStatus);
    }

    unselectAll();

    await fetchData();
    /* await fetchOTRequestData();
        await fetchLeaveRequestData();
        await fetchChangeOfScheduleRequestData(); 
        await fetchChangeLogRequestData();  */

    setEditData("");
    setLoadingRequest(false);
    closeMassApproveConfirmation();
    closeMassDisapproveConfirmation();
  };
  const handleStatusBulk = async (event, reqData, updateStatus) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrl = domain + "/api/TransactionRequest/status/bulk-update";
    let data = [];

    for (const item of reqData) {
      const dataToPush = {
        id: item.id,
        approverId: user.employeePersonalInformationId, //temporary
        status: updateStatus,
        requestTypeId: item.requestTypeId,
      };

      data.push(dataToPush);
    }

    try {
      await axios.put(apiUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");

      // Reload table data and reset form fields
      /* if(userAccess.description === "HR Head"){
                fetchDataHR();
            } else {
                fetchData();
            }
            fetchOTRequestData();
            fetchLeaveRequestData();
            fetchChangeOfScheduleRequestData(); 
            fetchChangeLogRequestData(); 
            setEditData(""); */

      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Request Successful");
    } catch (error) {
      console.error("There was a problem updating data:", error);
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    closeMassApproveConfirmation();
    closeMassDisapproveConfirmation();
  };
  const fetchOTRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(overTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [overTimeApiUrl]
  );
  const fetchLeaveRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(leaveTimeApiUrl + `/${data.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        });
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [leaveTimeApiUrl]
  );
  const fetchChangeOfScheduleRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeOfScheduleTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeOfScheduleTimeApiUrl]
  );
  const fetchChangeLogRequest = useCallback(
    async (data) => {
      setLoadingRequest(true);
      try {
        const response = await axios.get(
          changeLogRequestTimeApiUrl + `/${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // You can include other headers if needed
            },
          }
        );
        return response.data; // Set the response data to the state
      } catch (error) {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
        return [];
      } finally {
        setLoadingRequest(false);
      }
    },
    [changeLogRequestTimeApiUrl]
  );

  const approveHandleClick = async (data) => {
    if (data.status === "Approved") {
      setApproveMessage(true);
      return;
    } else if (data.status === "Disapproved") {
      setDisapproveMessage(true);
      return;
    } else if (data.status === "Cancelled") {
      setCancelledMessage(true);
      return;
    }

    if (data.requestTypeDescription === "Leave Request") {
      const _data = await fetchLeaveRequest(data);
      setEditData(_data);
      setApproveFormLeave(true);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    } else if (data.requestTypeDescription === "Change Schedule") {
      const _data = await fetchChangeOfScheduleRequest(data);
      setEditData(_data);
      setApproveFormChangeSchedule(true);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    } else if (data.requestTypeDescription === "Overtime Request") {
      const _data = await fetchOTRequest(data);
      setEditData(_data);
      setApproveFormOT(true);
      setHours(_data.hours);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    } else if (data.requestTypeDescription === "Change Log Request") {
      const _data = await fetchChangeLogRequest(data);
      setEditData(_data);
      setApproveFormChangeLogRequest(true);
      setSelectedItinerary(_data.changeLogItineraries);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    setRequestType(data.requestTypeDescription);
  };
  const disapproveHandleClick = async (data) => {
    if (data.status === "Approved") {
      setApproveMessage(true);
      return;
    } else if (data.status === "Disapproved") {
      setDisapproveMessage(true);
      return;
    } else if (data.status === "Cancelled") {
      setCancelledMessage(true);
      return;
    }

    if (data.requestTypeDescription === "Leave Request") {
      const _data = await fetchLeaveRequest(data);
      setEditData(_data);
      setDisapproveFormLeave(true);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    } else if (data.requestTypeDescription === "Change Schedule") {
      const _data = await fetchChangeOfScheduleRequest(data);
      setEditData(_data);
      setDisapproveFormChangeSchedule(true);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    } else if (data.requestTypeDescription === "Overtime Request") {
      const _data = await fetchOTRequest(data);
      setEditData(_data);
      setDisapproveFormOT(true);
      setHours(_data.hours);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    } else if (data.requestTypeDescription === "Change Log Request") {
      const _data = await fetchChangeLogRequest(data);
      setEditData(_data);
      setDisapproveFormChangeLogRequest(true);
      setSelectedItinerary(_data.changeLogItineraries);

      let filesToBeSet = [];

      if (_data.content) {
        const binaryData = atob(_data.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }

    setRequestType(data.requestTypeDescription);
  };
  const viewHandleClick = async (data) => {
    setViewById(data.id);
    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      const requestDataWithId = await fetchOTRequest(data);
      setShowViewOTForm(true);
      setReferenceNumber(requestDataWithId.referenceNumber);
      setApproverIdOT(requestDataWithId.approverId);
      setApproverNameOT(requestDataWithId.approverFullName);
      setStatusOT(requestDataWithId.status);
      setDateRequested(requestDataWithId.dateRequested);
      setDateCompleted(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setRequestTypeId(requestDataWithId.requestTypeId);
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);
      setReasonForRejection(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      const requestDataWithId = await fetchLeaveRequest(data);
      setShowViewLeaveForm(true);
      setReferenceNumberLeave(requestDataWithId.referenceNumber);
      setEmployeePersonalInformationIdLeave(
        requestDataWithId.employeePersonalInformationId
      );
      setApproverIdLeave(requestDataWithId.approverId);
      setApproverNameLeave(requestDataWithId.approverFullName);
      setRequestTypeIdLeave(requestDataWithId.requestTypeId);
      setStatusLeave(requestDataWithId.status);
      setDateRequestedLeave(requestDataWithId.dateRequested);
      setDateCompletedLeave(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);
      setReasonForRejectionLeave(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      setShowViewChangeScheduleForm(true);
      setReferenceNumberChangeSchedule(requestDataWithId.referenceNumber);
      setEmployeePersonalInformationIdChangeSchedule(
        requestDataWithId.employeePersonalInformationId
      );
      setApproverIdChangeSchedule(requestDataWithId.approverId);
      setApproverNameChangeSchedule(requestDataWithId.approverFullName);
      setRequestTypeIdChangeSchedule(requestDataWithId.requestTypeId);
      setStatusChangeSchedule(requestDataWithId.status);
      setDateRequestedChangeSchedule(requestDataWithId.dateRequested);
      setDateCompletedChangeSchedule(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);
      setReasonForRejectionChangeSchedule(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      const requestDataWithId = await fetchChangeLogRequest(data);
      setShowViewChangeLogRequestForm(true);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }
  };
  const editHandleClick = async (data) => {
    setViewById(data.id);
    setRequestType(data.requestTypeDescription);

    if (data.requestTypeDescription === "Overtime Request") {
      const requestDataWithId = await fetchOTRequest(data);
      openUpdateFormOT();
      setReferenceNumber(requestDataWithId.referenceNumber);
      setApproverIdOT(requestDataWithId.approverId);
      setApproverNameOT(requestDataWithId.approverFullName);
      setStatusOT(requestDataWithId.status);
      setDateRequested(requestDataWithId.dateRequested);
      setDateCompleted(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullName(
        requestDataWithId.employeePersonalInformationFullName
      );
      setEmployeePersonalInformationId(
        requestDataWithId.employeePersonalInformationId
      );
      setRequestTypeId(requestDataWithId.requestTypeId);
      setOvertimeType(requestDataWithId.overtimeType);
      setDate(requestDataWithId.date);
      setHours(requestDataWithId.hours);
      setHasOvertimeAllowance(requestDataWithId.hasOvertimeAllowance);
      setIsAboveTwoHoursOvertime(requestDataWithId.isAboveTwoHoursOvertime);
      setReason(requestDataWithId.reason);
      setReasonForRejection(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesOT(filesToBeSet);
    }

    if (data.requestTypeDescription === "Leave Request") {
      const requestDataWithId = await fetchLeaveRequest(data);
      openUpdateFormLeave();
      setReferenceNumberLeave(requestDataWithId.referenceNumber);
      setEmployeePersonalInformationIdLeave(
        requestDataWithId.employeePersonalInformationId
      );
      setApproverIdLeave(requestDataWithId.approverId);
      setApproverNameLeave(requestDataWithId.approverFullName);
      setRequestTypeIdLeave(requestDataWithId.requestTypeId);
      setStatusLeave(requestDataWithId.status);
      setDateRequestedLeave(requestDataWithId.dateRequested);
      setDateCompletedLeave(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullNameLeave(
        requestDataWithId.employeePersonalInformationFullName
      );
      setLeaveType(requestDataWithId.leaveTypeId);
      setDateFromLeave(requestDataWithId.dateFrom);
      setDateToLeave(requestDataWithId.dateTo);
      setDaysLeave(requestDataWithId.days);
      setIsHalfDayLeave(requestDataWithId.isHalfDay);
      setReasonLeave(requestDataWithId.reason);
      setReasonForRejectionLeave(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesLeave(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Schedule") {
      const requestDataWithId = await fetchChangeOfScheduleRequest(data);
      openUpdateFormChangeSchedule();
      setReferenceNumberChangeSchedule(requestDataWithId.referenceNumber);
      setEmployeePersonalInformationIdChangeSchedule(
        requestDataWithId.employeePersonalInformationId
      );
      setApproverIdChangeSchedule(requestDataWithId.approverId);
      setApproverNameChangeSchedule(requestDataWithId.approverFullName);
      setRequestTypeIdChangeSchedule(requestDataWithId.requestTypeId);
      setStatusChangeSchedule(requestDataWithId.status);
      setDateRequestedChangeSchedule(requestDataWithId.dateRequested);
      setDateCompletedChangeSchedule(requestDataWithId.dateCompleted);
      setEmployeePersonalInformationFullNameChangeSchedule(
        requestDataWithId.employeePersonalInformationFullName
      );
      setDateFromChangeSchedule(requestDataWithId.dateFrom);
      setDateToChangeSchedule(requestDataWithId.dateTo);
      setShiftScheduleFromId(requestDataWithId.shiftScheduleFromId);
      setShiftScheduleToId(requestDataWithId.shiftScheduleToId);
      setReasonChangeSchedule(requestDataWithId.reason);
      setReasonForRejectionChangeSchedule(requestDataWithId.reasonForRejection);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeSchedule(filesToBeSet);
    }

    if (data.requestTypeDescription === "Change Log Request") {
      const requestDataWithId = await fetchChangeLogRequest(data);
      openUpdateFormChangeLog();
      setReferenceNumberChangeLog(requestDataWithId.referenceNumber);
      setEmployeePersonalInformationIdChangeLogRequest(
        requestDataWithId.employeePersonalInformationId
      );
      setEmployeePersonalInformationFullNameChangeLogRequest(
        requestDataWithId.employeePersonalInformationFullName
      );
      setTimeTypeChangeLogRequest(requestDataWithId.timeType);
      setDateChangeLogRequest(requestDataWithId.date);
      setTimeRequestedChangeLogRequest(requestDataWithId.timeRendered);
      setReasonChangeLogRequest(requestDataWithId.reason);
      setReasonForRejectionChangeLogRequest(
        requestDataWithId.reasonForRejection
      );
      setSelectedItinerary(requestDataWithId.changeLogItineraries);

      let filesToBeSet = [];

      if (requestDataWithId.content) {
        const binaryData = atob(requestDataWithId.content);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: "image/jpeg" }); // Adjust the MIME type as per your data

        const file = new File([blob], "filename.jpg", { type: "image/jpeg" }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setFilesChangeLog(filesToBeSet);
    }
  };

  const viewImage = (data) => {
    setViewImageData(data);
    setShowViewImage(true);
  };
  const closeViewImage = () => {
    setShowViewImage(false);
  };

  const closeViewHandleClick = () => {
    if (requestType === "Overtime Request") {
      setShowViewOTForm(false);
    }

    if (requestType === "Leave Request") {
      setShowViewLeaveForm(false);
    }

    if (requestType === "Change Schedule") {
      setShowViewChangeScheduleForm(false);
    }

    if (requestType === "Change Log Request") {
      setShowViewChangeLogRequestForm(false);
    }
  };
  const closeViewOTApproverForm = () => {
    setShowViewOTApproverForm(false);
  };
  const closeViewLeaveApproverForm = () => {
    setShowViewLeaveApproverForm(false);
  };
  const closeViewChangeRequestApproverForm = () => {
    setShowViewChangeRequestApproverForm(false);
  };
  const closeApproveLeaveForm = () => {
    setApproveFormLeave(false);
  };
  const closeDisapproveLeaveForm = () => {
    setDisapproveFormLeave(false);
  };
  const closeApproveChangeScheduleForm = () => {
    setApproveFormChangeSchedule(false);
  };
  const closeDisapproveChangeScheduleForm = () => {
    setDisapproveFormChangeSchedule(false);
  };
  const closeApproveOTForm = () => {
    setApproveFormOT(false);
  };
  const closeDisapproveOTForm = () => {
    setDisapproveFormOT(false);
  };
  const closeApproveChangeLogRequestForm = () => {
    setApproveFormChangeLogRequest(false);
  };
  const closeDisapproveChangeLogRequestForm = () => {
    setDisapproveFormChangeLogRequest(false);
  };
  const closeConfirmationHandleClick = () => {
    setApproveConfirmation(false);
  };

  useEffect(() => {
    switch (filterDataIndexForOvertimeList) {
      case 0:
        setSearchPlaceholder("Employee Name");
        break;
      case 1:
        setSearchPlaceholder("Employee Name");
        break;
      case 2:
        setSearchPlaceholder("Employee Id");
        break;
      default:
        setSearchPlaceholder("Employee Name");
        break;
    }
  }, [filterDataIndexForOvertimeList]);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessageForOvertimeList({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  //send sms
  const sendSms = async (data, status, recipientInfo) => {
    if (!recipientInfo.mobileNumber) {
      return;
    }

    const composeMessage = `Hello,

Your request (${data.requestTypeDescription}) has been ${status} by ${
      user.employeePersonalInformationFullName
    }.

Please check reference number ${formattedReferenceNumber(data)} in the portal.`;

    const smsData = {
      requestTypeId: data.requestTypeId,
      date: new Date(),
      senderId: user.employeePersonalInformationId,
      senderFullName: user.employeePersonalInformationFullName,
      message: composeMessage,
      recipientId: recipientInfo.id,
      recipientFullName: recipientInfo.fullName,
      recipientMobileNumber: formatPhoneNumber(recipientInfo.mobileNumber), // phoneNumber
    };

    try {
      const response = await axios.post(
        "http://161.49.93.114:8081/api/Sms/send-sms",
        smsData
      ); // euro asia
      // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
      console.log(
        response,
        `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
      );
    } catch (error) {
      console.error(
        `Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`,
        error
      );
      console.log(
        `Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
      );
    }
  };
  const formatPhoneNumber = (number) => {
    // Remove all dashes
    const cleanedNumber = number.replace(/-/g, "");

    // Check if the number starts with '0' and remove it
    const formattedNumber = cleanedNumber.startsWith("0")
      ? "+63" + cleanedNumber.slice(1)
      : "+63" + cleanedNumber;

    return formattedNumber;
  };
  const formattedReferenceNumber = (data) => {
    const formattedNumber = data.referenceNumber.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return `LV-${formattedNumber}`;
    } else if (data.requestTypeId === 2) {
      return `CS-${formattedNumber}`;
    } else if (data.requestTypeId === 3) {
      return `OT-${formattedNumber}`;
    } else if (data.requestTypeId === 4) {
      return `CH-${formattedNumber}`;
    } else if (data.requestTypeId === 5) {
      return `OS-${formattedNumber}`;
    }
  };

  useEffect(() => {
    if (filterDataIndex !== currentFilterDataIndex) {
      setCurrentFilterDataIndex(filterDataIndex);
      setIsChangeFilter(true);
    }

    if (filterDataIndex2 !== currentFilterDataIndex2) {
      setCurrentFilterDataIndex2(filterDataIndex2);
      setIsChangeFilter(true);
    }
  }, [
    filterDataIndex,
    filterDataIndex2,
    currentFilterDataIndex,
    currentFilterDataIndex2,
  ]);

  const unselectAll = () => {
    setSelected([]);
    setActiveRowIds([]);
    setIsSelectAll(false);
  };

  const updateDaysRange = () => {
    setDaysRange(daysRangeTemp);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo shadow-xl">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions >"}{" "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Request Approval Time Keeper"}
                </span>
              </div>
              <h3>Request Approval Time Keeper</h3>
            </div>
            <div className="transaction-body">
              <div className="loan-tab overtimelist">
                <div>
                  <div className="filters-payroll">
                    <span>Filter</span>
                    <div
                      className="payroll-item-holder info-item-holder row"
                      style={{
                        padding: "0 10px 20px 10px",
                        justifyContent: "normal",
                      }}
                    >
                      <div className="filter-item-payroll popUp-item info-item column">
                        <div className="info-item-label">Request Type</div>
                        <div className="info-item-input">
                          {Filter(setFilterDataIndex)}
                        </div>
                      </div>
                      <div
                        className="filter-item-payroll popUp-item info-item column"
                        style={{ display: "none" }}
                      >
                        <div className="info-item-label">
                          Track Approver Status
                        </div>
                        <div className="info-item-input">
                          {Filter2(setFilterDataIndex2)}
                        </div>
                      </div>
                      <div
                        className="filter-item-payroll popUp-item info-item column"
                        style={{ display: "none" }}
                      >
                        <div className="info-item-label">Sort</div>
                        <div className="info-item-input">
                          {Sort(sortFilter, setSortFilter)}
                        </div>
                      </div>
                      <div
                        className="filter-item-payroll popUp-item info-item column"
                        style={{ display: "none" }}
                      >
                        <div className="info-item-label">Department</div>
                        <div className="info-item-input">
                          <DepartmentIdSelect
                            departmentId={departmentIdFilter}
                            setDepartmentId={setDepartmentIdFilter}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="filter-item-payroll popUp-item info-item row"
                      style={{ alignItems: "center" }}
                    >
                      <div className="info-item-label">Days Range: </div>
                      <div
                        className="info-item-input"
                        style={{ marginLeft: "5px" }}
                      >
                        <input
                          id="employeePersonalInformationFullName"
                          placeholder="Days Range"
                          value={daysRangeTemp}
                          onChange={(e) => setDaysRangeTemp(e.target.value)}
                          type="number"
                        />
                      </div>
                      <div style={{ marginLeft: "5px" }}>
                        {CreateButton(
                          "",
                          "update-days-range row",
                          updateDaysRange,
                          "UPDATE",
                          UpdateIcon
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="transaction-body-top row"
                    style={{ justifyContent: "space-between" }}
                  >
                    {CreateSearchBarWithPlaceHolder(
                      "",
                      "transaction-search row",
                      "transaction-search-icon",
                      "transaction-search-input",
                      (e) => handleFilter(e.target.value),
                      "Search by Employee Id",
                      SearchIcon
                    )}
                  </div>
                  <div
                    className="body-top-btn mass-approval-btn row"
                    style={{ padding: "5px 0", display: "none" }}
                  >
                    <div style={{ margin: "5px" }}>
                      {CreateButton(
                        "",
                        "select-all row",
                        triggerSelectAll,
                        "SELECT ALL",
                        ChecklistIcon
                      )}
                    </div>
                    <div style={{ margin: "5px" }}>
                      {CreateButton(
                        "",
                        "approve row",
                        openMassApproveConfirmation,
                        "APPROVE",
                        ThumbUpIcon
                      )}
                    </div>
                    <div style={{ marginLeft: "5px" }}>
                      {CreateButton(
                        "",
                        "disapprove row",
                        openMassDispproveConfirmation,
                        "DISAPPROVE",
                        ThumbDownAltIcon
                      )}
                    </div>
                  </div>
                  <div className="transaction-table container">
                    <CreateTable
                      dataList={requestApproval}
                      dataHeader={header}
                      dataAccessor={accessor}
                      approveHandleClick={approveHandleClick}
                      disapproveHandleClick={disapproveHandleClick}
                      viewHandleClick={viewHandleClick}
                      editHandleClick={editHandleClick}
                      viewImage={viewImage}
                      overtimeRequestData={overtimeRequestData}
                      leaveRequestData={leaveRequestData}
                      changeOfScheduleData={changeOfScheduleData}
                      changeLogRequestData={changeLogRequestData}
                      isChangeFilter={isChangeFilter}
                      setIsChangeFilter={setIsChangeFilter}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setSelected={setSelected}
                      isSelectAll={isSelectAll}
                      setIsSelectAll={setIsSelectAll}
                      activeRowIds={activeRowIds}
                      setActiveRowIds={setActiveRowIds}
                      userAccess={userAccess}
                      // dummy
                      setOvertimeRequestData={setOvertimeRequestData}
                      setLeaveRequestData={setLeaveRequestData}
                      setChangeOfScheduleData={setChangeOfScheduleData}
                      setChangeLogRequestData={setChangeLogRequestData}
                      setFilterDataForOvertimeList={
                        setFilterDataForOvertimeList
                      }
                      isGenerate={isGenerate}
                    />
                  </div>
                </div>
                <Tabs
                  selectedIndex={selectedTab}
                  onSelect={(index) => handleSelectChange(index)}
                  style={{ display: "none" }}
                >
                  <TabList>
                    <Tab>
                      <b>{`OVERTIME LIST (WORKERS)`}</b>
                    </Tab>
                    <Tab>
                      <b>{`FOR APPROVAL`}</b>
                    </Tab>
                  </TabList>
                  <div className="loan-tabPanel">
                    <TabPanel>
                      <div
                        className="payroll-item-holder info-item-holder row"
                        style={{
                          alignItems: "center",
                          justifyContent: "normal",
                          padding: "0 20px 20px 20px",
                        }}
                      >
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">Date</div>
                          <div className="info-item-input">
                            <DateTimeInput
                              date={downloadDate}
                              setDate={setDownloadDate}
                            />
                          </div>
                          <span
                            style={{
                              visibility:
                                !downloadDate && errorState
                                  ? "visible"
                                  : "hidden",
                              color: "#ff6565",
                              fontSize: "12px",
                            }}
                          >
                            Please fill up this field
                          </span>
                        </div>
                        <div className="top-filter">
                          {CreateButton(
                            "",
                            "generate row",
                            handleGenerate,
                            "GENERATE",
                            RestartAltIcon
                          )}
                        </div>
                      </div>
                      <div style={{ padding: "0 20px" }}>
                        {FilterForOvertimeList(
                          setFilterDataIndexForOvertimeList
                        )}
                        <div className="transaction-body-top row">
                          {CreateSearchBarWithPlaceHolder(
                            "",
                            "transaction-search row",
                            "transaction-search-icon",
                            "transaction-search-input",
                            (e) => handleFilterForOvertimeList(e.target.value),
                            `Search by ${searchPlaceholder}`,
                            SearchIcon
                          )}
                          <div className="transaction-addBtn row">
                            {CreateButton(
                              "",
                              "approve row",
                              handleConfirmationApproveFromOvertimeList,
                              "APPROVE",
                              DoneIcon
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="transaction-table container">
                        <CreateTableForOvertimeList
                          dataList={overtimeRequestDataForOvertimeList}
                          dataHeader={headerForOvertimeList}
                          dataAccessor={accessorForOvertimeList}
                          selectedToAdd={selectedToAdd}
                          setSelectedToAdd={setSelectedToAdd}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      {Filter(setFilterDataIndex)}
                      <div className="transaction-body-top row">
                        {CreateSearchBarWithPlaceHolder(
                          "",
                          "transaction-search row",
                          "transaction-search-icon",
                          "transaction-search-input",
                          (e) => handleFilter(e.target.value),
                          "Search by Employee Id",
                          SearchIcon
                        )}
                      </div>
                      <div className="transaction-table container">
                        <CreateTable
                          dataList={requestApproval}
                          dataHeader={header}
                          dataAccessor={accessor}
                          approveHandleClick={approveHandleClick}
                          disapproveHandleClick={disapproveHandleClick}
                          viewHandleClick={viewHandleClick}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>
                    </TabPanel>
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewOTForm
        isOpen={showViewOTForm}
        onClose={closeViewHandleClick}
        referenceNumber={referenceNumber}
        approverIdOT={approverIdOT}
        approverNameOT={approverNameOT}
        statusOT={statusOT}
        dateRequested={dateRequested}
        dateCompleted={dateCompleted}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        requestTypeId={requestTypeId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        reasonForRejection={reasonForRejection}
        setReferenceNumber={setReferenceNumber}
        setStatusOT={setStatusOT}
        setDateRequested={setDateRequested}
        setDateCompleted={setDateCompleted}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setRequestTypeId={setRequestTypeId}
        setOvertimeType={setOvertimeType}
        setDate={setDate}
        setHours={setHours}
        setHasOvertimeAllowance={setHasOvertimeAllowance}
        setIsAboveTwoHoursOvertime={setIsAboveTwoHoursOvertime}
        setReason={setReason}
        setReasonForRejection={setReasonForRejection}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
        handleUpdate={handleOTUpdateDetails}
      ></ViewOTForm>
      <ViewLeaveForm
        isOpen={showViewLeaveForm}
        onClose={closeViewHandleClick}
        referenceNumberLeave={referenceNumberLeave}
        employeePersonalInformationIdLeave={employeePersonalInformationIdLeave}
        approverIdLeave={approverIdLeave}
        approverNameLeave={approverNameLeave}
        requestTypeIdLeave={requestTypeIdLeave}
        statusLeave={statusLeave}
        dateRequestedLeave={dateRequestedLeave}
        dateCompletedLeave={dateCompletedLeave}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        reasonForRejectionLeave={reasonForRejectionLeave}
        setReferenceNumberLeave={setReferenceNumberLeave}
        setEmployeePersonalInformationIdLeave={
          setEmployeePersonalInformationIdLeave
        }
        setApproverIdLeave={setApproverIdLeave}
        setRequestTypeIdLeave={setRequestTypeIdLeave}
        setStatusLeave={setStatusLeave}
        setDateRequestedLeave={setDateRequestedLeave}
        setDateCompletedLeave={setDateCompletedLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        setDaysLeave={setDaysLeave}
        setIsHalfDayLeave={setIsHalfDayLeave}
        setReasonLeave={setReasonLeave}
        setReasonForRejectionLeave={setReasonForRejectionLeave}
        setShowViewLeaveApproverForm={setShowViewLeaveApproverForm}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
        handleUpdate={handleLeaveUpdateDetails}
      ></ViewLeaveForm>
      <ViewChangeScheduleForm
        isOpen={showViewChangeScheduleForm}
        onClose={closeViewHandleClick}
        referenceNumberChangeSchedule={referenceNumberChangeSchedule}
        employeePersonalInformationIdChangeSchedule={
          employeePersonalInformationIdChangeSchedule
        }
        approverIdChangeSchedule={approverIdChangeSchedule}
        approverNameChangeSchedule={approverNameChangeSchedule}
        requestTypeIdChangeSchedule={requestTypeIdChangeSchedule}
        statusChangeSchedule={statusChangeSchedule}
        dateRequestedChangeSchedule={dateRequestedChangeSchedule}
        dateCompletedChangeSchedule={dateCompletedChangeSchedule}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        reasonForRejectionChangeSchedule={reasonForRejectionChangeSchedule}
        setReferenceNumberChangeSchedule={setReferenceNumberChangeSchedule}
        setEmployeePersonalInformationIdChangeSchedule={
          setEmployeePersonalInformationIdChangeSchedule
        }
        setRequestTypeIdChangeSchedule={setRequestTypeIdChangeSchedule}
        setStatusChangeSchedule={setStatusChangeSchedule}
        setDateRequestedChangeSchedule={setDateRequestedChangeSchedule}
        setDateCompletedChangeSchedule={setDateCompletedChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        setReasonChangeSchedule={setReasonChangeSchedule}
        setReasonForRejectionChangeSchedule={
          setReasonForRejectionChangeSchedule
        }
        setShowViewChangeRequestApproverForm={
          setShowViewChangeRequestApproverForm
        }
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
        handleUpdate={handleChangeScheduleUpdateDetails}
      ></ViewChangeScheduleForm>
      <ViewChangeLogRequestForm
        isOpen={showViewChangeLogRequestForm}
        onClose={closeViewHandleClick}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        handleUpdate={handleChangeLogRequestUpdateDetails}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        data={selectedItinerary}
        viewImage={viewImage}
      ></ViewChangeLogRequestForm>

      <UpdateOTForm
        isOpen={showUpdateOTForm}
        onClose={closeUpdateFormOT}
        referenceNumber={referenceNumber}
        approverIdOT={approverIdOT}
        approverNameOT={approverNameOT}
        statusOT={statusOT}
        dateRequested={dateRequested}
        dateCompleted={dateCompleted}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        requestTypeId={requestTypeId}
        overtimeType={overtimeType}
        date={date}
        hours={hours}
        hasOvertimeAllowance={hasOvertimeAllowance}
        isAboveTwoHoursOvertime={isAboveTwoHoursOvertime}
        reason={reason}
        reasonForRejection={reasonForRejection}
        setReferenceNumber={setReferenceNumber}
        setStatusOT={setStatusOT}
        setDateRequested={setDateRequested}
        setDateCompleted={setDateCompleted}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setRequestTypeId={setRequestTypeId}
        setOvertimeType={setOvertimeType}
        setDate={setDate}
        setHours={setHours}
        setHasOvertimeAllowance={setHasOvertimeAllowance}
        setIsAboveTwoHoursOvertime={setIsAboveTwoHoursOvertime}
        setReason={setReason}
        setReasonForRejection={setReasonForRejection}
        handleUpdate={handleOTUpdateDetails}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></UpdateOTForm>
      <UpdateLeaveForm
        isOpen={showUpdateLeaveForm}
        onClose={closeUpdateFormLeave}
        referenceNumberLeave={referenceNumberLeave}
        employeePersonalInformationIdLeave={employeePersonalInformationIdLeave}
        approverIdLeave={approverIdLeave}
        approverNameLeave={approverNameLeave}
        requestTypeIdLeave={requestTypeIdLeave}
        statusLeave={statusLeave}
        dateRequestedLeave={dateRequestedLeave}
        dateCompletedLeave={dateCompletedLeave}
        employeePersonalInformationFullNameLeave={
          employeePersonalInformationFullNameLeave
        }
        leaveType={leaveType}
        dateFromLeave={dateFromLeave}
        dateToLeave={dateToLeave}
        daysLeave={daysLeave}
        isHalfDayLeave={isHalfDayLeave}
        reasonLeave={reasonLeave}
        reasonForRejectionLeave={reasonForRejectionLeave}
        setReferenceNumberLeave={setReferenceNumberLeave}
        setEmployeePersonalInformationIdLeave={
          setEmployeePersonalInformationIdLeave
        }
        setApproverIdLeave={setApproverIdLeave}
        setRequestTypeIdLeave={setRequestTypeIdLeave}
        setStatusLeave={setStatusLeave}
        setDateRequestedLeave={setDateRequestedLeave}
        setDateCompletedLeave={setDateCompletedLeave}
        setEmployeePersonalInformationFullNameLeave={
          setEmployeePersonalInformationFullNameLeave
        }
        setLeaveType={setLeaveType}
        setDateFromLeave={setDateFromLeave}
        setDateToLeave={setDateToLeave}
        setDaysLeave={setDaysLeave}
        setIsHalfDayLeave={setIsHalfDayLeave}
        setReasonLeave={setReasonLeave}
        setReasonForRejectionLeave={setReasonForRejectionLeave}
        setShowViewLeaveApproverForm={setShowViewLeaveApproverForm}
        handleUpdate={handleLeaveUpdateDetails}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></UpdateLeaveForm>
      <UpdateChangeScheduleForm
        isOpen={showUpdateChangeScheduleForm}
        onClose={closeUpdateFormChangeSchedule}
        referenceNumberChangeSchedule={referenceNumberChangeSchedule}
        employeePersonalInformationIdChangeSchedule={
          employeePersonalInformationIdChangeSchedule
        }
        approverIdChangeSchedule={approverIdChangeSchedule}
        approverNameChangeSchedule={approverNameChangeSchedule}
        requestTypeIdChangeSchedule={requestTypeIdChangeSchedule}
        statusChangeSchedule={statusChangeSchedule}
        dateRequestedChangeSchedule={dateRequestedChangeSchedule}
        dateCompletedChangeSchedule={dateCompletedChangeSchedule}
        employeePersonalInformationFullNameChangeSchedule={
          employeePersonalInformationFullNameChangeSchedule
        }
        dateFromChangeSchedule={dateFromChangeSchedule}
        dateToChangeSchedule={dateToChangeSchedule}
        shiftScheduleFromId={shiftScheduleFromId}
        shiftScheduleToId={shiftScheduleToId}
        reasonChangeSchedule={reasonChangeSchedule}
        reasonForRejectionChangeSchedule={reasonForRejectionChangeSchedule}
        setReferenceNumberChangeSchedule={setReferenceNumberChangeSchedule}
        setEmployeePersonalInformationIdChangeSchedule={
          setEmployeePersonalInformationIdChangeSchedule
        }
        setRequestTypeIdChangeSchedule={setRequestTypeIdChangeSchedule}
        setStatusChangeSchedule={setStatusChangeSchedule}
        setDateRequestedChangeSchedule={setDateRequestedChangeSchedule}
        setDateCompletedChangeSchedule={setDateCompletedChangeSchedule}
        setEmployeePersonalInformationFullNameChangeSchedule={
          setEmployeePersonalInformationFullNameChangeSchedule
        }
        setDateFromChangeSchedule={setDateFromChangeSchedule}
        setDateToChangeSchedule={setDateToChangeSchedule}
        setShiftScheduleFromId={setShiftScheduleFromId}
        setShiftScheduleToId={setShiftScheduleToId}
        setReasonChangeSchedule={setReasonChangeSchedule}
        setReasonForRejectionChangeSchedule={
          setReasonForRejectionChangeSchedule
        }
        setShowViewChangeRequestApproverForm={
          setShowViewChangeRequestApproverForm
        }
        handleUpdate={handleChangeScheduleUpdateDetails}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></UpdateChangeScheduleForm>
      <UpdateChangeLogRequestForm
        isOpen={showUpdateChangeLogForm}
        onClose={closeUpdateFormChangeLog}
        employeePersonalInformationIdChangeLogRequest={
          employeePersonalInformationIdChangeLogRequest
        }
        employeePersonalInformationFullNameChangeLogRequest={
          employeePersonalInformationFullNameChangeLogRequest
        }
        timeTypeChangeLogRequest={timeTypeChangeLogRequest}
        dateChangeLogRequest={dateChangeLogRequest}
        timeRequestedChangeLogRequest={timeRequestedChangeLogRequest}
        statusChangeLogRequest={statusChangeLogRequest}
        reasonChangeLogRequest={reasonChangeLogRequest}
        reasonForRejectionChangeLogRequest={reasonForRejectionChangeLogRequest}
        setEmployeePersonalInformationIdChangeLogRequest={
          setEmployeePersonalInformationIdChangeLogRequest
        }
        setEmployeePersonalInformationFullNameChangeLogRequest={
          setEmployeePersonalInformationFullNameChangeLogRequest
        }
        setTimeTypeChangeLogRequest={setTimeTypeChangeLogRequest}
        setDateChangeLogRequest={setDateChangeLogRequest}
        setTimeRequestedChangeLogRequest={setTimeRequestedChangeLogRequest}
        setStatusChangeLogRequest={setStatusChangeLogRequest}
        setReasonChangeLogRequest={setReasonChangeLogRequest}
        setReasonForRejectionChangeLogRequest={
          setReasonForRejectionChangeLogRequest
        }
        handleUpdate={handleChangeLogRequestUpdateDetails}
        data={selectedItinerary}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        viewImage={viewImage}
      ></UpdateChangeLogRequestForm>

      <EditLeaveForm
        isOpen={approveFormLeave}
        onClose={closeApproveLeaveForm}
        isApprove={true}
        editData={editData}
        handleStatus={updateApprovals}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></EditLeaveForm>
      <EditLeaveForm
        isOpen={disapproveFormLeave}
        onClose={closeDisapproveLeaveForm}
        isApprove={false}
        editData={editData}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        files={filesLeave}
        setFiles={setFilesLeave}
        viewImage={viewImage}
      ></EditLeaveForm>
      <EditChangeScheduleForm
        isOpen={approveFormChangeSchedule}
        onClose={closeApproveChangeScheduleForm}
        isApprove={true}
        editData={editData}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></EditChangeScheduleForm>
      <EditChangeScheduleForm
        isOpen={disapproveFormChangeSchedule}
        onClose={closeDisapproveChangeScheduleForm}
        isApprove={false}
        editData={editData}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        files={filesChangeSchedule}
        setFiles={setFilesChangeSchedule}
        viewImage={viewImage}
      ></EditChangeScheduleForm>
      <EditOTForm
        isOpen={approveFormOT}
        onClose={closeApproveOTForm}
        isApprove={true}
        editData={editData}
        isHRHead={isHRHead}
        hours={hours}
        setHours={setHours}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></EditOTForm>
      <EditOTForm
        isOpen={disapproveFormOT}
        onClose={closeDisapproveOTForm}
        isApprove={false}
        editData={editData}
        isHRHead={isHRHead}
        hours={hours}
        setHours={setHours}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        files={filesOT}
        setFiles={setFilesOT}
        viewImage={viewImage}
      ></EditOTForm>
      <EditChangeLogRequestForm
        isOpen={approveFormChangeLogRequest}
        onClose={closeApproveChangeLogRequestForm}
        isApprove={true}
        editData={editData}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        data={selectedItinerary}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        viewImage={viewImage}
      ></EditChangeLogRequestForm>
      <EditChangeLogRequestForm
        isOpen={disapproveFormChangeLogRequest}
        onClose={closeDisapproveChangeLogRequestForm}
        isApprove={false}
        editData={editData}
        setGeneralReasonForRejection={setGeneralReasonForRejection}
        handleStatus={updateApprovals}
        data={selectedItinerary}
        files={filesChangeLog}
        setFiles={setFilesChangeLog}
        viewImage={viewImage}
      ></EditChangeLogRequestForm>

      <ViewOTApproverForm
        isOpen={showViewOTApproverForm}
        onClose={closeViewOTApproverForm}
        setApproverId={setApproverIdOT}
        setApproverName={setApproverNameOT}
      ></ViewOTApproverForm>
      <ViewLeaveApproverForm
        isOpen={showViewLeaveApproverForm}
        onClose={closeViewLeaveApproverForm}
        setApproverId={setApproverIdLeave}
        setApproverName={setApproverNameLeave}
      ></ViewLeaveApproverForm>
      <ViewChangeRequestApproverForm
        isOpen={showViewChangeRequestApproverForm}
        onClose={closeViewChangeRequestApproverForm}
        setApproverId={setApproverIdChangeSchedule}
        setApproverName={setApproverNameChangeSchedule}
      ></ViewChangeRequestApproverForm>
      <ConfirmationForm
        isOpen={approveConfirmation}
        onClose={closeConfirmationHandleClick}
        handleConfirm={handleApproveAllSelected}
      ></ConfirmationForm>
      <MassApproveConfirmation
        isOpen={massApproveConfirmation}
        onClose={closeMassApproveConfirmation}
        handleConfirm={updateApprovalsBulk}
      ></MassApproveConfirmation>
      <MassDispproveConfirmation
        isOpen={massDisapproveConfirmation}
        onClose={closeMassDisapproveConfirmation}
        handleConfirm={updateApprovalsBulk}
      ></MassDispproveConfirmation>
      <ViewImage
        isOpen={showViewImage}
        onClose={closeViewImage}
        viewImageData={viewImageData}
      ></ViewImage>

      <GenerateMessage
        form={approveMessage}
        message={"Already approved!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessage
        form={disapproveMessage}
        message={"Already disapproved!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessage
        form={cancelledMessage}
        message={"Already cancelled!"}
        isSuccess={false}
      ></GenerateMessage>
      <GenerateMessageForOvertimeList
        form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessageForOvertimeList>
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

function ViewOTForm({
  isOpen,
  onClose,
  referenceNumber,
  approverIdOT,
  approverNameOT,
  statusOT,
  dateRequested,
  dateCompleted,
  employeePersonalInformationFullName,
  employeePersonalInformationId,
  requestTypeId,
  overtimeType,
  date,
  hours,
  hasOvertimeAllowance,
  isAboveTwoHoursOvertime,
  reason,
  reasonForRejection,
  setReferenceNumber,
  setStatusOT,
  setDateRequested,
  setDateCompleted,
  setEmployeePersonalInformationFullName,
  setEmployeePersonalInformationId,
  setRequestTypeId,
  setOvertimeType,
  setDate,
  setHours,
  setHasOvertimeAllowance,
  setIsAboveTwoHoursOvertime,
  setReason,
  setReasonForRejection,
  setShowViewOTApproverForm,
  files,
  setFiles,
  handleUpdate,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Overtime Type</div>
                <div className="info-item-input">
                  <OvertimeTypeSelect
                    overtimeType={overtimeType}
                    setOvertimeType={setOvertimeType}
                    isView={true}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={date}
                      setDate={setDate}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="hours"
                      placeholder="Hours"
                      value={hours}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={hasOvertimeAllowance}
                      readOnly={true}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      With overtime allowance?
                    </h5>
                  </div>
                </div>
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-above2"
                      className="checkbox"
                      name=""
                      checked={isAboveTwoHoursOvertime}
                      readOnly={true}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      Above two hours overtime?
                    </h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    readOnly={true}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewLeaveForm({
  isOpen,
  onClose,
  referenceNumberLeave,
  employeePersonalInformationIdLeave,
  approverIdLeave,
  approverNameLeave,
  requestTypeIdLeave,
  statusLeave,
  dateRequestedLeave,
  dateCompletedLeave,
  employeePersonalInformationFullNameLeave,
  leaveType,
  dateFromLeave,
  dateToLeave,
  daysLeave,
  isHalfDayLeave,
  reasonLeave,
  reasonForRejectionLeave,
  setReferenceNumberLeave,
  setEmployeePersonalInformationIdLeave,
  setRequestTypeIdLeave,
  setStatusLeave,
  setDateRequestedLeave,
  setDateCompletedLeave,
  setEmployeePersonalInformationFullNameLeave,
  setLeaveType,
  setDateFromLeave,
  setDateToLeave,
  setDaysLeave,
  setIsHalfDayLeave,
  setReasonLeave,
  setReasonForRejectionLeave,
  setShowViewLeaveApproverForm,
  files,
  setFiles,
  approveHandleClick,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameLeave}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullNameLeave(
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  <LeaveTypeSelect
                    leaveType={leaveType}
                    setLeaveType={setLeaveType}
                    isView={true}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateFromLeave}
                      setDate={setDateFromLeave}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateToLeave}
                      setDate={setDateToLeave}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      readOnly
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={daysLeave}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      readOnly
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={isHalfDayLeave}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonLeave}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewChangeScheduleForm({
  isOpen,
  onClose,
  referenceNumberChangeSchedule,
  employeePersonalInformationIdChangeSchedule,
  approverIdChangeSchedule,
  approverNameChangeSchedule,
  requestTypeIdChangeSchedule,
  statusChangeSchedule,
  dateRequestedChangeSchedule,
  dateCompletedChangeSchedule,
  employeePersonalInformationFullNameChangeSchedule,
  dateFromChangeSchedule,
  dateToChangeSchedule,
  shiftScheduleFromId,
  shiftScheduleToId,
  reasonChangeSchedule,
  reasonForRejectionChangeSchedule,
  setReferenceNumberChangeSchedule,
  setEmployeePersonalInformationIdChangeSchedule,
  setRequestTypeIdChangeSchedule,
  setStatusChangeSchedule,
  setDateRequestedChangeSchedule,
  setDateCompletedChangeSchedule,
  setEmployeePersonalInformationFullNameChangeSchedule,
  setDateFromChangeSchedule,
  setDateToChangeSchedule,
  setShiftScheduleFromId,
  setShiftScheduleToId,
  setReasonChangeSchedule,
  setReasonForRejectionChangeSchedule,
  setShowViewChangeRequestApproverForm,
  files,
  setFiles,
  handleUpdate,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameChangeSchedule"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameChangeSchedule}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateFromChangeSchedule}
                      setDate={setDateFromChangeSchedule}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateToChangeSchedule}
                      setDate={setDateToChangeSchedule}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule From</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={shiftScheduleFromId}
                      setShiftScheduleId={setShiftScheduleFromId}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule To</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={shiftScheduleToId}
                      setShiftScheduleId={setShiftScheduleToId}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeSchedule}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewChangeLogRequestForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeLogRequest,
  timeTypeChangeLogRequest,
  dateChangeLogRequest,
  timeRequestedChangeLogRequest,
  reasonChangeLogRequest,
  setTimeTypeChangeLogRequest,
  setDateChangeLogRequest,
  setTimeRequestedChangeLogRequest,
  files,
  setFiles,
  data,
  viewImage,
}) {
  var header = ["Time In", "Time Out", "Location"];
  var accessor = ["timeIn", "timeOut", "location"];

  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Request Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameChangeSchedule"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationFullNameChangeLogRequest
                      }
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Type</div>
                  <div className="info-item-input">
                    <TimeTypeSelect
                      timeType={timeTypeChangeLogRequest}
                      setTimeType={setTimeTypeChangeLogRequest}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateChangeLogRequest}
                      setDate={setDateChangeLogRequest}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Requested</div>
                  <div className="info-item-input">
                    <TimeInput
                      date={timeRequestedChangeLogRequest}
                      setDate={setTimeRequestedChangeLogRequest}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeLogRequest}
                    readOnly
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Itinerary</div>
                <div className="info-item-input">
                  <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                  >
                    <CreateTable
                      dataList={data}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                  {data && data.length > 0 ? (
                    <div></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      {/*<p>No records to display</p>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function UpdateOTForm({
  isOpen,
  onClose,
  referenceNumber,
  approverIdOT,
  approverNameOT,
  statusOT,
  dateRequested,
  dateCompleted,
  employeePersonalInformationFullName,
  employeePersonalInformationId,
  requestTypeId,
  overtimeType,
  date,
  hours,
  hasOvertimeAllowance,
  isAboveTwoHoursOvertime,
  reason,
  reasonForRejection,
  setReferenceNumber,
  setStatusOT,
  setDateRequested,
  setDateCompleted,
  setEmployeePersonalInformationFullName,
  setEmployeePersonalInformationId,
  setRequestTypeId,
  setOvertimeType,
  setDate,
  setHours,
  setHasOvertimeAllowance,
  setIsAboveTwoHoursOvertime,
  setReason,
  setReasonForRejection,
  setShowViewOTApproverForm,
  handleUpdate,
  files,
  setFiles,
  viewImage,
}) {
  const handleClose = () => {
    onClose();
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();

    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }
    }

    setFiles(fileList);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullName"
                    placeholder="Employee"
                    value={employeePersonalInformationFullName}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullName(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Overtime Type</div>
                <div className="info-item-input">
                  <OvertimeTypeSelect
                    overtimeType={overtimeType}
                    setOvertimeType={setOvertimeType}
                    isView={false}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={date}
                      setDate={setDate}
                      isView={false}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="hours"
                      placeholder="Hours"
                      value={hours}
                      onChange={(e) => setHours(e.target.value)}
                      readOnly={false}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={hasOvertimeAllowance}
                      onChange={(e) =>
                        setHasOvertimeAllowance(e.target.checked)
                      }
                      readOnly={false}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      With overtime allowance?
                    </h5>
                  </div>
                </div>
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-above2"
                      className="checkbox"
                      name=""
                      checked={isAboveTwoHoursOvertime}
                      onChange={(e) =>
                        setIsAboveTwoHoursOvertime(e.target.checked)
                      }
                      readOnly={false}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>
                      Above two hours overtime?
                    </h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    readOnly={false}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={
                              file
                                ? URL.createObjectURL(file)
                                : "images/sample.jpg"
                            }
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                UDPATE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function UpdateLeaveForm({
  isOpen,
  onClose,
  referenceNumberLeave,
  employeePersonalInformationIdLeave,
  approverIdLeave,
  approverNameLeave,
  requestTypeIdLeave,
  statusLeave,
  dateRequestedLeave,
  dateCompletedLeave,
  employeePersonalInformationFullNameLeave,
  leaveType,
  dateFromLeave,
  dateToLeave,
  daysLeave,
  isHalfDayLeave,
  reasonLeave,
  reasonForRejectionLeave,
  setReferenceNumberLeave,
  setEmployeePersonalInformationIdLeave,
  setRequestTypeIdLeave,
  setStatusLeave,
  setDateRequestedLeave,
  setDateCompletedLeave,
  setEmployeePersonalInformationFullNameLeave,
  setLeaveType,
  setDateFromLeave,
  setDateToLeave,
  setDaysLeave,
  setIsHalfDayLeave,
  setReasonLeave,
  setReasonForRejectionLeave,
  setShowViewLeaveApproverForm,
  approveHandleClick,
  files,
  setFiles,
  viewImage,
  handleUpdate,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameLeave}
                    onChange={(e) =>
                      setEmployeePersonalInformationFullNameLeave(
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  <LeaveTypeSelect
                    leaveType={leaveType}
                    setLeaveType={setLeaveType}
                    isView={false}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateFromLeave}
                      setDate={setDateFromLeave}
                      isView={false}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateToLeave}
                      setDate={setDateToLeave}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={daysLeave}
                      onChange={(e) => setDaysLeave(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={isHalfDayLeave}
                      onChange={(e) => setIsHalfDayLeave(e.target.checked)}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonLeave}
                    onChange={(e) => setReasonLeave(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                UDPATE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function UpdateChangeScheduleForm({
  isOpen,
  onClose,
  referenceNumberChangeSchedule,
  employeePersonalInformationIdChangeSchedule,
  approverIdChangeSchedule,
  approverNameChangeSchedule,
  requestTypeIdChangeSchedule,
  statusChangeSchedule,
  dateRequestedChangeSchedule,
  dateCompletedChangeSchedule,
  employeePersonalInformationFullNameChangeSchedule,
  dateFromChangeSchedule,
  dateToChangeSchedule,
  shiftScheduleFromId,
  shiftScheduleToId,
  reasonChangeSchedule,
  reasonForRejectionChangeSchedule,
  setReferenceNumberChangeSchedule,
  setEmployeePersonalInformationIdChangeSchedule,
  setRequestTypeIdChangeSchedule,
  setStatusChangeSchedule,
  setDateRequestedChangeSchedule,
  setDateCompletedChangeSchedule,
  setEmployeePersonalInformationFullNameChangeSchedule,
  setDateFromChangeSchedule,
  setDateToChangeSchedule,
  setShiftScheduleFromId,
  setShiftScheduleToId,
  setReasonChangeSchedule,
  setReasonForRejectionChangeSchedule,
  setShowViewChangeRequestApproverForm,
  files,
  setFiles,
  viewImage,
  handleUpdate,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameChangeSchedule"
                    placeholder="Employee"
                    value={employeePersonalInformationFullNameChangeSchedule}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateFromChangeSchedule}
                      setDate={setDateFromChangeSchedule}
                      isView={false}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateToChangeSchedule}
                      setDate={setDateToChangeSchedule}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule From</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={shiftScheduleFromId}
                      setShiftScheduleId={setShiftScheduleFromId}
                      isView={false}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule To</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={shiftScheduleToId}
                      setShiftScheduleId={setShiftScheduleToId}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeSchedule}
                    onChange={(e) => setReasonChangeSchedule(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                UDPATE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function UpdateChangeLogRequestForm({
  isOpen,
  onClose,
  employeePersonalInformationFullNameChangeLogRequest,
  timeTypeChangeLogRequest,
  dateChangeLogRequest,
  timeRequestedChangeLogRequest,
  reasonChangeLogRequest,
  setTimeTypeChangeLogRequest,
  setDateChangeLogRequest,
  setTimeRequestedChangeLogRequest,
  setReasonChangeLogRequest,
  handleUpdate,
  files,
  setFiles,
  viewImage,
  data,
}) {
  var header = ["Time In", "Time Out", "Location"];
  var accessor = ["timeIn", "timeOut", "location"];

  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Details</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameChangeSchedule"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationFullNameChangeLogRequest
                      }
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Type</div>
                  <div className="info-item-input">
                    <TimeTypeSelect
                      timeType={timeTypeChangeLogRequest}
                      setTimeType={setTimeTypeChangeLogRequest}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput
                      date={dateChangeLogRequest}
                      setDate={setDateChangeLogRequest}
                      isView={false}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Requested</div>
                  <div className="info-item-input">
                    <TimeInput
                      date={timeRequestedChangeLogRequest}
                      setDate={setTimeRequestedChangeLogRequest}
                      isView={false}
                    />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reasonChangeLogRequest}
                    onChange={(e) => setReasonChangeLogRequest(e.target.value)}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Itinerary</div>
                <div className="info-item-input">
                  <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                  >
                    <CreateTable
                      dataList={data}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                  {data && data.length > 0 ? (
                    <div></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      {/*<p>No records to display</p>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={handleUpdate}
              >
                UDPATE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditLeaveForm({
  isOpen,
  onClose,
  isApprove,
  editData,
  setGeneralReasonForRejection,
  files,
  setFiles,
  viewImage,
  handleStatus,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={editData.employeePersonalInformationFullName}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Leave Type</div>
                <div className="info-item-input">
                  <LeaveTypeSelect
                    leaveType={editData.leaveTypeId}
                    isView={true}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.dateFrom} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.dateTo} isView={true} />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Days</div>
                  <div className="info-item-input">
                    <input
                      readOnly
                      type="number"
                      id="daysLeave"
                      placeholder="Days"
                      value={editData.days}
                    />
                  </div>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="transaction-form-item row">
                  <div
                    className="transaction-form-input"
                    style={{ width: "auto" }}
                  >
                    <input
                      type="checkbox"
                      readOnly
                      id="overtime-allowance"
                      className="checkbox"
                      name=""
                      checked={editData.isHalfDay}
                    />
                  </div>
                  <div
                    className="transaction-form-category"
                    style={{ padding: "0 10px" }}
                  >
                    <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={editData.reason}
                    readOnly
                  />
                </div>
              </div>
              {isApprove ? (
                <></>
              ) : (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reason For Rejection</div>
                  <div className="info-item-input">
                    <textarea
                      id="tamper"
                      className="filterSelect"
                      style={{
                        width: "100%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                      }}
                      // value={editData.reason}
                      onChange={(e) =>
                        setGeneralReasonForRejection(e.target.value)
                      }
                    />
                  </div>
                </div>
              )}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={(e) =>
                  handleStatus(e, isApprove ? "Approved" : "Disapproved")
                }
              >
                {isApprove ? "APPROVE" : "DISAPPROVE"}
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewImage({ isOpen, onClose, viewImageData }) {
  const [imageSource, setImageSource] = useState("");

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    if (isOpen && viewImageData.content instanceof File) {
      const reader = new FileReader();

      reader.onloadend = () => {
        // Once the file is read, set the image source to the base64 data
        setImageSource(reader.result);
      };

      // Read the file as a Data URL (which includes the base64 encoding)
      reader.readAsDataURL(viewImageData.content);
    }
  }, [isOpen, viewImageData]);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const openImage = () => {
    setIsImageModalOpen(true); // Open image in full view
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false); // Close full image modal
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Uploaded Image</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  className="modal-events-image"
                  src={imageSource}
                  alt=""
                  style={{ width: "250px", height: "auto" }}
                  onClick={openImage}
                />
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Full Image Modal */}
      {isImageModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeImageModal} // Click outside to close
        >
          <img
            src={imageSource}
            alt="Full view"
            style={{ maxWidth: "90%", maxHeight: "90%" }}
          />
        </div>
      )}
    </>
  );
}
function EditOTForm({
  isOpen,
  onClose,
  isApprove,
  editData,
  isHRHead,
  hours,
  setHours,
  setGeneralReasonForRejection,
  files,
  setFiles,
  viewImage,
  handleStatus,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={editData.employeePersonalInformationFullName}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Overtime Type</div>
                <div className="info-item-input">
                  <OvertimeTypeSelect
                    overtimeType={editData.overtimeType}
                    isView={true}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.date} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Hours</div>
                  <div className="info-item-input">
                    <input
                      readOnly={!isHRHead}
                      placeholder="Hours"
                      value={hours}
                      onChange={(e) => setHours(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="transaction-from-splitItem row">
                  <div className="transaction-form-item row">
                    <div
                      className="transaction-form-input"
                      style={{ width: "auto" }}
                    >
                      <input
                        type="checkbox"
                        readOnly
                        id="overtime-allowance"
                        className="checkbox"
                        name=""
                        checked={editData.hasOvertimeAllowance}
                      />
                    </div>
                    <div
                      className="transaction-form-category"
                      style={{ padding: "0 10px" }}
                    >
                      <h5 style={{ fontWeight: "normal" }}>
                        With overtime allowance?
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="transaction-from-splitItem row">
                  <div className="transaction-form-item row">
                    <div
                      className="transaction-form-input"
                      style={{ width: "auto" }}
                    >
                      <input
                        type="checkbox"
                        readOnly
                        id="overtime-allowance"
                        className="checkbox"
                        name=""
                        checked={editData.isAboveTwoHoursOvertime}
                      />
                    </div>
                    <div
                      className="transaction-form-category"
                      style={{ padding: "0 10px" }}
                    >
                      <h5 style={{ fontWeight: "normal" }}>
                        Above two hours overtime?
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={editData.reason}
                    readOnly
                  />
                </div>
              </div>
              {isApprove ? (
                <></>
              ) : (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reason For Rejection</div>
                  <div className="info-item-input">
                    <textarea
                      id="tamper"
                      className="filterSelect"
                      style={{
                        width: "100%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                      }}
                      // value={editData.reason}
                      onChange={(e) =>
                        setGeneralReasonForRejection(e.target.value)
                      }
                    />
                  </div>
                </div>
              )}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={(e) =>
                  handleStatus(e, isApprove ? "Approved" : "Disapproved")
                }
              >
                {isApprove ? "APPROVE" : "DISAPPROVE"}
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditChangeScheduleForm({
  isOpen,
  onClose,
  isApprove,
  editData,
  setGeneralReasonForRejection,
  files,
  setFiles,
  viewImage,
  handleStatus,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly={true}
                    id="employeePersonalInformationFullNameLeave"
                    placeholder="Employee"
                    value={editData.employeePersonalInformationFullName}
                  />
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule From</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={editData.shiftScheduleFromId}
                      isView={true}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Shift Schedule To</div>
                  <div className="info-item-input">
                    <ShiftScheduleIdSelect
                      shiftScheduleId={editData.shiftScheduleToId}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.dateFrom} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.dateTo} isView={true} />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={editData.reason}
                    readOnly
                  />
                </div>
              </div>
              {isApprove ? (
                <></>
              ) : (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reason For Rejection</div>
                  <div className="info-item-input">
                    <textarea
                      id="tamper"
                      className="filterSelect"
                      style={{
                        width: "100%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                      }}
                      // value={editData.reason}
                      onChange={(e) =>
                        setGeneralReasonForRejection(e.target.value)
                      }
                    />
                  </div>
                </div>
              )}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={(e) =>
                  handleStatus(e, isApprove ? "Approved" : "Disapproved")
                }
              >
                {isApprove ? "APPROVE" : "DISAPPROVE"}
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditChangeLogRequestForm({
  isOpen,
  onClose,
  isApprove,
  editData,
  setGeneralReasonForRejection,
  handleStatus,
  files,
  setFiles,
  viewImage,
  data,
}) {
  var header = ["Time In", "Time Out", "Location"];
  var accessor = ["timeIn", "timeOut", "location"];

  const [currentPage, setCurrentPage] = useState(1);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Request</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Employee</div>
                  <div className="info-item-input">
                    <input
                      readOnly={true}
                      id="employeePersonalInformationFullNameLeave"
                      placeholder="Employee"
                      value={editData.employeePersonalInformationFullName}
                    />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Type</div>
                  <div className="info-item-input">
                    <TimeTypeSelect
                      timeType={editData.timeType}
                      isView={true}
                    />
                  </div>
                </div>
              </div>
              <div className="info-item-holder row">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date</div>
                  <div className="info-item-input">
                    <DateTimeInput date={editData.date} isView={true} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Time Requested</div>
                  <div className="info-item-input">
                    <TimeInput date={editData.timeRendered} isView={true} />
                  </div>
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Reason</div>
                <div className="info-item-input">
                  <textarea
                    id="tamper"
                    className="filterSelect"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={editData.reason}
                    readOnly
                  />
                </div>
              </div>
              {isApprove ? (
                <></>
              ) : (
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Reason For Rejection</div>
                  <div className="info-item-input">
                    <textarea
                      id="tamper"
                      className="filterSelect"
                      style={{
                        width: "100%",
                        minHeight: "50px",
                        borderRadius: "3px",
                        border: "1px solid #80808080",
                        color: "rgb(104, 104, 104)",
                      }}
                      // value={editData.reason}
                      onChange={(e) =>
                        setGeneralReasonForRejection(e.target.value)
                      }
                    />
                  </div>
                </div>
              )}
              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  {files.length > 0 && (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img
                            src={file ? URL.createObjectURL(file) : ""}
                            alt=""
                            style={{ width: "150px", height: "auto" }}
                            onClick={() => viewImage({ content: file })}
                          ></img>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Itinerary</div>
                <div className="info-item-input">
                  <div
                    className="users-table container"
                    style={{ overflow: "unset" }}
                  >
                    <CreateTable
                      dataList={data}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                  {data && data.length > 0 ? (
                    <div></div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      {/*<p>No records to display</p>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                style={{ marginRight: "5px" }}
                onClick={(e) =>
                  handleStatus(e, isApprove ? "Approved" : "Disapproved")
                }
              >
                {isApprove ? "APPROVE" : "DISAPPROVE"}
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  approveHandleClick,
  disapproveHandleClick,
  viewHandleClick,
  editHandleClick,
  viewImage,
  approvals,
  hierarchy,
  listOfEmployees,
  overtimeRequestData,
  leaveRequestData,
  changeOfScheduleData,
  changeLogRequestData,

  isChangeFilter,
  setIsChangeFilter,

  currentPage,
  setCurrentPage,

  setSelected,
  isSelectAll,
  setIsSelectAll,
  activeRowIds,
  setActiveRowIds,

  userAccess,
}) {
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    if (isChangeFilter) {
      setCurrentPage(1);
      setIsChangeFilter(false);
    }
  }, [isChangeFilter, setIsChangeFilter, setCurrentPage]);

  useEffect(() => {
    if (isSelectAll) {
      const newActiveRowIds = rows.map((item) => item.original.id);
      const newActiveRowOriginal = rows.map((item) => item.original);
      setActiveRowIds(newActiveRowIds);
      setSelected(newActiveRowOriginal);
      setIsSelectAll(false);
    }
  }, [isSelectAll, setIsSelectAll, setSelected, rows, setActiveRowIds]);

  const handleRowClick = (rowData) => {
    setSelected((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (item) => item.id === rowData.id
      );
      return isAlreadySelected
        ? prevSelected.filter((item) => item.id !== rowData.id) // Remove rowData if already selected
        : [...prevSelected, rowData]; // Add rowData if not selected
    });
    setActiveRowIds(
      (prevIds) =>
        prevIds.includes(rowData.id)
          ? prevIds.filter((id) => id !== rowData.id) // Remove the row ID if it is already active
          : [...prevIds, rowData.id] // Add the new row ID if it is not already active
    );
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={
                  activeRowIds?.includes(row.original.id) ? "active" : ""
                } // Check if row ID is in the array
              >
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    approveHandleClick,
                    disapproveHandleClick,
                    viewHandleClick,
                    editHandleClick,
                    viewImage,
                    approvals,
                    hierarchy,
                    listOfEmployees,
                    overtimeRequestData,
                    leaveRequestData,
                    changeOfScheduleData,
                    changeLogRequestData,
                    userAccess,
                    activeRowIds?.includes(row.original.id)
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function CreateTableForOvertimeList({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  setSelectedEmployee,
  selectedToAdd,
  setSelectedToAdd,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  // const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // const handleRowClick = (rowData) => {
  //     setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
  //     setActiveRowId(rowData.id);
  // };

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                // onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                // className={row.original.id === activeRowId ? 'active' : ''}
              >
                {row.cells.map((cell) => (
                  <SetInfoForOvertimeList
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                    selectedToAdd={selectedToAdd}
                    setSelectedToAdd={setSelectedToAdd}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function CreateTableForEmployeeSelect({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
  setSelectedEmployee,
}) {
  // const [currentPage, setCurrentPage] = useState(1);
  const [activeRowId, setActiveRowId] = useState(null);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowClick = (rowData) => {
    setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
    setActiveRowId(rowData.id);
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                className={row.original.id === activeRowId ? "active" : ""}
              >
                {row.cells.map((cell) =>
                  SetInfo(cell.render("Cell").props.column.Header, cell)
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo(
  header,
  _cell,
  approveHandleClick,
  disapproveHandleClick,
  viewHandleClick,
  editHandleClick,
  viewImage,
  approvals,
  hierarchy,
  listOfEmployees,
  overtimeRequestData,
  leaveRequestData,
  changeOfScheduleData,
  changeLogRequestData,
  userAccess,
  isActive
) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Approve">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => approveHandleClick(data)}
            >
              <ThumbUpIcon />
            </div>
          </Tooltip>
          <Tooltip text="Disapprove">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => disapproveHandleClick(data)}
            >
              <ThumbDownAltIcon />
            </div>
          </Tooltip>
          <Tooltip text="View">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => viewHandleClick(data)}
            >
              <RemoveRedEyeIcon />
            </div>
          </Tooltip>
          {userAccess.description === "HR Head" &&
            data.status === "Approved" &&
            data.requestTypeId === 3 && (
              <Tooltip text="Update">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => editHandleClick(data)}
                >
                  <ModeEditIcon />
                </div>
              </Tooltip>
            )}
        </div>
      </td>
    );
  }

  if (header === " ") {
    let isSelected = isActive;

    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={isSelected}
        />
      </td>
    );
  }

  if (header === "Track Approvers") {
    const trackApproval = data.approval;

    if (!trackApproval) {
      return (
        <td>
          <>
            {`Primary Approver: Pending`}
            <br />
            <br />
            {`Secondary Approver: Pending`}
            <br />
            <br />
            {`Tertiary Approver: Pending`}
            <br />
            <br />
          </>
        </td>
      );
    }

    return (
      <td>
        <>
          {trackApproval.primaryApproverId !== undefined && (
            <>
              <span>{`Primary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.primaryApproverStatus}
              >{`${
                trackApproval.primaryApproverStatus !== ""
                  ? trackApproval.primaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.primaryApproverStatus === "Approved" ||
                trackApproval.primaryApproverStatus === "Disapproved") &&
                trackApproval.primaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.primaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
          {trackApproval.secondaryApproverId !== undefined && (
            <>
              <span>{`Secondary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.secondaryApproverStatus}
              >{`${
                trackApproval.secondaryApproverStatus !== ""
                  ? trackApproval.secondaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.secondaryApproverStatus === "Approved" ||
                trackApproval.secondaryApproverStatus === "Disapproved") &&
                trackApproval.secondaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.secondaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
          {trackApproval.tertiaryApproverId !== undefined && (
            <>
              <span>{`Tertiary Approver: `}</span>
              <span
                style={{ padding: "1px 5px" }}
                className={trackApproval.tertiaryApproverStatus}
              >{`${
                trackApproval.tertiaryApproverStatus !== ""
                  ? trackApproval.tertiaryApproverStatus
                  : "Pending"
              }`}</span>
              {(trackApproval.tertiaryApproverStatus === "Approved" ||
                trackApproval.tertiaryApproverStatus === "Disapproved") &&
                trackApproval.tertiaryApproverFullName && (
                  <span
                    style={{ padding: "1px 5px" }}
                  >{`- ${trackApproval.tertiaryApproverFullName}`}</span>
                )}
              <br />
              <br />
            </>
          )}
        </>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.requestTypeId === 1) {
      //Leave
      if (leaveRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = leaveRequestData.find((_data) => _data.id === data.id);
      if (foundData.content) {
        return (
          <td>
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <Tooltip text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </Tooltip>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 2) {
      //Change Schedule
      if (changeOfScheduleData.length <= 0) {
        return <td></td>;
      }
      const foundData = changeOfScheduleData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <Tooltip text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </Tooltip>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 3) {
      //OT
      if (overtimeRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = overtimeRequestData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <Tooltip text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </Tooltip>
            </div>
          </td>
        );
      }
      return <td></td>;
    } else if (data.requestTypeId === 4) {
      // Change Log
      if (changeLogRequestData.length <= 0) {
        return <td></td>;
      }
      const foundData = changeLogRequestData.find(
        (_data) => _data.id === data.id
      );
      if (foundData.content) {
        return (
          <td>
            <div
              className="row"
              style={{ alignItems: "center", justifyContent: "center" }}
            >
              <Tooltip text="View Image">
                <div
                  style={{ padding: "0 5px" }}
                  onClick={() => viewImage(foundData)}
                >
                  <ImageIcon />
                </div>
              </Tooltip>
            </div>
          </td>
        );
      }
      return <td></td>;
    }
  }

  if (header === "Status") {
    let convertedValue = value;

    if (convertedValue === "Sent") {
      convertedValue = "Pending";
    }
    return <td className={convertedValue}>{convertedValue}</td>;
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Request Date") {
    const date = new Date(data.requestDate);

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (
    header === "Time In" ||
    header === "Time Out" ||
    header === "Time Rendered"
  ) {
    const time = _cell.render("Cell").props.value;

    if (!time) {
      return <td>-</td>;
    }

    let formattedTime = "";

    // Attempt to parse the time if it’s not already in ISO format
    let date;
    if (time.includes("T")) {
      date = new Date(time);
    } else {
      // If the time is not in ISO format, manually create the date
      const currentDate = new Date(); // Get current date for the date portion
      const [hours, minutes] = time
        .split(":")
        .map((part) => parseInt(part, 10));

      if (isNaN(hours) || isNaN(minutes)) {
        return <td>Invalid time format</td>;
      }

      date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        hours,
        minutes
      );
    }

    if (isNaN(date.getTime())) {
      return <td>Invalid time format</td>;
    }

    // Convert to desired format YYYY-MM-DDTHH:mm
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    // const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    // console.log(formattedDateTime); // Logs the converted time for debugging

    // Further formatting based on globalTimeFormat
    if (globalTimeFormat === "Standard Time") {
      const amPm = date.getHours() >= 12 ? "PM" : "AM";
      const standardHours = date.getHours() % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${standardHours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function SetInfoForOvertimeList({
  header,
  _cell,
  selectedToAdd,
  setSelectedToAdd,
}) {
  const data = _cell.render("Cell").props.row.original;
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(data.status === "Approved");
  }, [data]);

  const handleItem = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);

    if (checked) {
      setSelectedToAdd((prevItems) => [...prevItems, data]);
    } else {
      setSelectedToAdd((prevItems) => prevItems.filter((i) => i !== data));
    }
  };

  if (header === "Approve") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={isChecked}
          onChange={handleItem}
          disabled={data.status !== "Sent" && data.status !== "Pending"}
        />
      </td>
    );
  }

  if (header === "Type") {
    const value = _cell.render("Cell").props.value;

    function formatString(str) {
      const formattedStr = str.replace(/([A-Z])/g, " $1").trim();

      return formattedStr
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    }

    return <td>{formatString(value)}</td>;
  }

  if (header === "Date") {
    const date = new Date(data.date);

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
// function OvertimeTypeSelect({ overtimeType, setOvertimeType, isView }) {
//   const [isSelected, setIsSelected] = useState(false);

//   const handleSelectChange = (event) => {
//     setIsSelected(true);
//     setOvertimeType(event.target.value);
//   };

//   useEffect(() => {
//     if (overtimeType !== "") {
//       setIsSelected(true);
//     } else {
//       setIsSelected(false);
//     }
//   }, [overtimeType]);

//   return (
//     <div>
//       <select
//         id="employee-select-PagibigReport"
//         disabled={isView}
//         value={overtimeType}
//         onChange={handleSelectChange}
//         style={{
//           color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
//         }}
//       >
//         <option value="" disabled hidden>
//           Choose overtime type
//         </option>
//         <option value="Regular">Regular</option>
//         <option value="Restday">Restday</option>
//         <option value="SpecialHoliday">Special Holiday</option>
//         <option value="RegularHoliday">Regular Holiday</option>
//         <option value="RestdaySpecialHoliday">Restday Special Holiday</option>
//         <option value="RestdayRegularHoliday">Restday Regular Holiday</option>
//       </select>
//     </div>
//   );
// }
function LeaveTypeSelect({ leaveType, setLeaveType, isView }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLeaveType(event.target.value);
  };

  const [leaveTypes, setLeaveTypes] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/LeaveType";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setLeaveTypes(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    if (leaveType !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [leaveType]);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        disabled={isView}
        value={leaveType}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose leave type
        </option>
        {leaveTypes.map((leaveType) => SetLeaveType(leaveType))}
      </select>
    </div>
  );
}
function SetLeaveType(leaveType) {
  return (
    <option id={"leaveType" + leaveType.id} value={leaveType.id}>
      {leaveType.id + " - " + leaveType.description}
    </option>
  );
}
function DateTimeInput({ date, setDate, isView }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  let formattedDate = "";

  if (date) {
    formattedDate = date.split("T")[0];
  }

  return (
    <div>
      <input
        readOnly={isView}
        type="date"
        id={"datetime-"}
        name="datetime"
        value={formattedDate} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function TimeInput({ date, setDate, isView }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  let timePart = "";

  if (date) {
    timePart = date.split("T")[1].substring(0, 5);
  }

  return (
    <div>
      <input
        readOnly={isView}
        type="time"
        id={"datetime-"}
        name="datetime"
        value={timePart} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function ShiftScheduleIdSelect({
  shiftScheduleId,
  setShiftScheduleId,
  isView,
}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setShiftScheduleId(event.target.value);
  };

  const [shiftScheduleIds, setShiftScheduleIds] = useState([]);

  const apiUrl = domain + "/api/ShiftSchedule";

  const fetchData = useCallback(async () => {
    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setShiftScheduleIds(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [apiUrl]);

  useEffect(() => {
    fetchData();

    if (shiftScheduleId !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [fetchData, shiftScheduleId]);

  return (
    <div>
      <select
        id="overtime-employee-name"
        disabled={isView}
        value={shiftScheduleId}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose shift schedule
        </option>
        {shiftScheduleIds.map((shiftScheduleId) =>
          SetShiftScheduleId(shiftScheduleId)
        )}
      </select>
    </div>
  );
}
function SetShiftScheduleId(shiftScheduleId) {
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  };

  return (
    <option
      id={"overtimeAdd" + shiftScheduleId.id}
      value={shiftScheduleId.id}
    >{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(
      shiftScheduleId.timeFrom
    )} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
  );
}
function DepartmentIdSelect({ departmentId, setDepartmentId }) {
  const handleSelectChange = (event) => {
    setDepartmentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Department/active";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        response.data.sort((a, b) =>
          a.description.localeCompare(b.description)
        );
        setData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <select
        id="employee-select-PagibigReport"
        value={departmentId}
        onChange={handleSelectChange}
        style={{ color: "rgb(104, 104, 104)" }}
      >
        <option value={0}>All</option>
        {data.map((departmentId) => SetDepartmentId(departmentId))}
      </select>
    </div>
  );
}
function SetDepartmentId(departmentId) {
  return <option value={departmentId.id}>{departmentId.description}</option>;
}
function TimeTypeSelect({ timeType, setTimeType }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setTimeType(event.target.value);
  };

  useEffect(() => {
    if (timeType !== "" && timeType !== null) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [timeType]);

  return (
    <div>
      <select
        id="timeType"
        value={timeType}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose Time Type
        </option>
        <option value="In">Time-In</option>
        <option value="Out">Time-Out</option>
        <option value="NoIn">No-In</option>
        <option value="NoOut">No-Out</option>
      </select>
    </div>
  );
}
function ViewOTApproverForm({
  isOpen,
  onClose,
  setApproverId,
  setApproverName,
}) {
  var header = ["Id", "Name"];
  var accessor = [
    "employeePersonalInformationId",
    "employeePersonalInformationFullName",
  ];

  const handleClose = () => {
    onClose();
  };
  const handleProceed = () => {
    onClose();
    setApproverId(selectedEmployee.employeePersonalInformationId);
    setApproverName(selectedEmployee.employeePersonalInformationFullName);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setEmployees(response.data); // Set the response data to the state
        setFilterData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewLeaveApproverForm({
  isOpen,
  onClose,
  setApproverId,
  setApproverName,
}) {
  var header = ["Id", "Name"];
  var accessor = [
    "employeePersonalInformationId",
    "employeePersonalInformationFullName",
  ];

  const handleClose = () => {
    onClose();
  };
  const handleProceed = () => {
    onClose();
    setApproverId(selectedEmployee.employeePersonalInformationId);
    setApproverName(selectedEmployee.employeePersonalInformationFullName);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setEmployees(response.data); // Set the response data to the state
        setFilterData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ViewChangeRequestApproverForm({
  isOpen,
  onClose,
  setApproverId,
  setApproverName,
}) {
  var header = ["Id", "Name"];
  var accessor = [
    "employeePersonalInformationId",
    "employeePersonalInformationFullName",
  ];

  const handleClose = () => {
    onClose();
  };
  const handleProceed = () => {
    onClose();
    setApproverId(selectedEmployee.employeePersonalInformationId);
    setApproverName(selectedEmployee.employeePersonalInformationFullName);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setEmployees(response.data); // Set the response data to the state
        setFilterData(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div> {/*<p>No records to display</p>*/}</div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function Filter(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "Leave Request":
        setFilterDataIndex(1);
        break;
      case "Change Schedule":
        setFilterDataIndex(2);
        break;
      case "Overtime Request":
        setFilterDataIndex(3);
        break;
      case "Change Log Request":
        setFilterDataIndex(4);
        break;
      case "See All Requests":
        setFilterDataIndex(5);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      <option value="All">All</option>
      <option value="Leave Request">Leave Request</option>
      <option value="Change Schedule">Change Schedule</option>
      <option value="Overtime Request">Overtime Request</option>
      <option value="Change Log Request">Change Log Request</option>
      {/* <option value="See All Requests">See All Requests</option> */}
    </select>
  );
}
function Filter2(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "Pending":
        setFilterDataIndex(1);
        break;
      case "Approved":
        setFilterDataIndex(2);
        break;
      case "Disapproved":
        setFilterDataIndex(3);
        break;
      case "Cancelled":
        setFilterDataIndex(4);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
      style={{ color: "rgb(104, 104, 104)" }}
    >
      <option value="All">All</option>
      <option value="Pending">Pending</option>
      <option value="Approved">Approved</option>
      <option value="Disapproved">Disapproved</option>
      {/* <option value="Cancelled">Cancelled</option> */}
    </select>
  );
}
function Sort(filterDataIndex, setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setFilterDataIndex(event.target.value);
  };

  useEffect(() => {
    if (filterDataIndex !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [filterDataIndex]);

  return (
    <select
      id=""
      className="filterSelect"
      value={selectedOption}
      onChange={handleSelectChange}
      style={{
        color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
      }}
    >
      <option value="" disabled hidden>{`Choose filter`}</option>
      <option value="Reference Number ↑">{`Reference Number ↑`}</option>
      <option value="Reference Number ↓">{`Reference Number ↓`}</option>
      <option value="Request Date ↑">{`Request Date ↑`} </option>
      <option value="Request Date ↓">{`Request Date ↓`}</option>
      <option value="Employee (A to Z)">{`Employee (A to Z)`}</option>
      <option value="Employee (Z to A)">{`Employee (Z to A)`}</option>
    </select>
  );
}
function FilterForOvertimeList(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeName":
        setFilterDataIndex(1);
        break;
      case "EmployeeId":
        setFilterDataIndex(2);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeName">Employee Name</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function GenerateMessage({ form, message, isSuccess }) {
  return (
    <>
      <div
        className={`modal-overlay toggleMessage-overlay ${form ? "open" : ""}`}
      >
        {form && (
          <div
            className="modal toggleMessage"
            style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
          >
            <div className="column">
              {isSuccess ? (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    alignItems: "center",
                  }}
                >
                  <CheckCircleIcon />
                  <span>{"SUCCESS MESSAGE"}</span>
                </div>
              ) : (
                <div
                  className="request_title row"
                  style={{
                    fontWeight: "bold",
                    color: "#DD5746",
                    alignItems: "center",
                  }}
                >
                  <ErrorIcon />
                  <span>{"ERROR MESSAGE"}</span>
                </div>
              )}
              <span
                style={{
                  textAlign: "center",
                  padding: "10px 0",
                  color: isSuccess ? "green" : "#DD5746",
                }}
              >
                {message}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function ConfirmationForm({ isOpen, onClose, handleConfirm }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Overtime Approval</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to approve selected data?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleConfirm}
                style={{ marginRight: "5px" }}
              >
                APPROVE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function MassApproveConfirmation({ isOpen, onClose, handleConfirm }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Mass Approve</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to approve selected data?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => handleConfirm(e, "Approved")}
                style={{ marginRight: "5px" }}
              >
                APPROVE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function MassDispproveConfirmation({ isOpen, onClose, handleConfirm }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Mass Approve</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>Are you sure you want to disapprove selected data?</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => handleConfirm(e, "Disapproved")}
                style={{ marginRight: "5px" }}
              >
                DISAPPROVE
              </button>
              <button
                id="add-family"
                className="cancel row"
                style={{ height: "34px", borderRadius: "3px" }}
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default RequestApprovalTimeKeeper;
